(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };
},{"core-js/library/fn/array/from":5}],2:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };
},{"core-js/library/fn/object/assign":6}],3:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _assign = require("../core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
},{"../core-js/object/assign":2}],4:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _from = require("../core-js/array/from");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};
},{"../core-js/array/from":1}],5:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;

},{"../../modules/_core":12,"../../modules/es6.array.from":59,"../../modules/es6.string.iterator":61}],6:[function(require,module,exports){
require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;

},{"../../modules/_core":12,"../../modules/es6.object.assign":60}],7:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],8:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":28}],9:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":50,"./_to-iobject":52,"./_to-length":53}],10:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":11,"./_wks":57}],11:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],12:[function(require,module,exports){
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],13:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":37,"./_property-desc":44}],14:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":7}],15:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],16:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":20}],17:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":21,"./_is-object":28}],18:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],19:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var has = require('./_has');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":12,"./_ctx":14,"./_global":21,"./_has":22,"./_hide":23}],20:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],21:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],22:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],23:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":16,"./_object-dp":37,"./_property-desc":44}],24:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":21}],25:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":16,"./_dom-create":17,"./_fails":20}],26:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":11}],27:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":33,"./_wks":57}],28:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],29:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":8}],30:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":23,"./_object-create":36,"./_property-desc":44,"./_set-to-string-tag":46,"./_wks":57}],31:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":19,"./_hide":23,"./_iter-create":30,"./_iterators":33,"./_library":34,"./_object-gpo":40,"./_redefine":45,"./_set-to-string-tag":46,"./_wks":57}],32:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":57}],33:[function(require,module,exports){
module.exports = {};

},{}],34:[function(require,module,exports){
module.exports = true;

},{}],35:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = require('./_descriptors');
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

},{"./_descriptors":16,"./_fails":20,"./_iobject":26,"./_object-gops":39,"./_object-keys":42,"./_object-pie":43,"./_to-object":54}],36:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":8,"./_dom-create":17,"./_enum-bug-keys":18,"./_html":24,"./_object-dps":38,"./_shared-key":47}],37:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":8,"./_descriptors":16,"./_ie8-dom-define":25,"./_to-primitive":55}],38:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":8,"./_descriptors":16,"./_object-dp":37,"./_object-keys":42}],39:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],40:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":22,"./_shared-key":47,"./_to-object":54}],41:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":9,"./_has":22,"./_shared-key":47,"./_to-iobject":52}],42:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":18,"./_object-keys-internal":41}],43:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],44:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],45:[function(require,module,exports){
module.exports = require('./_hide');

},{"./_hide":23}],46:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":22,"./_object-dp":37,"./_wks":57}],47:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":48,"./_uid":56}],48:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":12,"./_global":21,"./_library":34}],49:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":15,"./_to-integer":51}],50:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":51}],51:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],52:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":15,"./_iobject":26}],53:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":51}],54:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":15}],55:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":28}],56:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],57:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":21,"./_shared":48,"./_uid":56}],58:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":10,"./_core":12,"./_iterators":33,"./_wks":57}],59:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":13,"./_ctx":14,"./_export":19,"./_is-array-iter":27,"./_iter-call":29,"./_iter-detect":32,"./_to-length":53,"./_to-object":54,"./core.get-iterator-method":58}],60:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":19,"./_object-assign":35}],61:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":31,"./_string-at":49}],62:[function(require,module,exports){
"use strict";

angular.module('app').constant('ROUTES', function () {
    return {
        SEARCH: '/search',
        SEARCH_WITH_PARAMS: '/search/:ticketNumber/:lastName',
        CHECK_IN: '/check-in',
        BOARDING_PASS: '/boarding-pass',
        PENDING_PAYMENT_STATUS: '/pending-payment-status'
    };
}());

angular.module('app').config(['$routeProvider', 'ROUTES', function ($routeProvider, ROUTES) {

    $routeProvider.when(ROUTES.SEARCH, {
        templateUrl: 'screens/search/search.html',
        controller: 'SearchScreenController',
        controllerAs: 'vm'
    }).when(ROUTES.SEARCH_WITH_PARAMS, {
        templateUrl: 'screens/search/search.html',
        controller: 'SearchScreenController',
        controllerAs: 'vm'
    }).when(ROUTES.CHECK_IN, {
        templateUrl: 'screens/check-in/check-in.html',
        controller: 'CheckInScreenController',
        controllerAs: 'vm'
    }).when(ROUTES.BOARDING_PASS, {
        templateUrl: 'screens/boarding-pass/boarding-pass.html',
        controller: 'BoardingPassScreenController',
        controllerAs: 'vm'
    }).when(ROUTES.PENDING_PAYMENT_STATUS, {
        templateUrl: 'screens/pending-payment-status/pending-payment-status.html',
        controller: 'PendingPaymentStatusScreenController',
        controllerAs: 'vm'
    }).otherwise({
        redirectTo: ROUTES.SEARCH
    });
}]);

},{}],63:[function(require,module,exports){
"use strict";

angular.module('app', ['ngRoute', 'ngSanitize', 'moment-picker', 'ui.select', 'ui.mask', 'swipe']);

require('./http.conf');

require('./filters');
require('./services');
require('./datepicker.conf');

require('./ROUTES');

require('./components');
require('./modals');
require('./screens');

angular.module('app').config(['$compileProvider', function ($compileProvider) {
    $compileProvider.debugInfoEnabled(false);
}]);

angular.module('app').run(['appInit', function (appInit) {
    appInit();
}]);

},{"./ROUTES":62,"./components":88,"./datepicker.conf":104,"./filters":109,"./http.conf":113,"./modals":114,"./screens":139,"./services":143}],64:[function(require,module,exports){
"use strict";

angular.module('app').component('alertMessage', {
    templateUrl: 'components/alert-message/alert-message.html',
    controller: [AlertMessageController],
    controllerAs: 'vm',
    bindings: {
        content: '=',
        role: '@?'
    }
});

function AlertMessageController() {

    var vm = this,
        defaultRole = 'info',
        iconByRole = {
        info: 'checkmark',
        error: 'attention'
    };

    if (!vm.role) {
        vm.role = defaultRole;
    }

    vm.iconCode = iconByRole[vm.role] || iconByRole[defaultRole];
}

},{}],65:[function(require,module,exports){
"use strict";

angular.module('app').component('appHeaderLanguage', {
    templateUrl: 'components/app-header-language/app-header-language.html',
    controller: ['$timeout', '$window', '$element', AppHeaderLanguageController],
    controllerAs: 'vm',
    bindings: {
        'currentLanguage': '<',
        'availableLanguages': '<',
        'onSelect': '&'
    }
});

function AppHeaderLanguageController($timeout, $window, $element) {

    var vm = this;
    vm.switchDrop = switchDrop;

    function switchDrop() {
        vm.showDrop = !vm.showDrop;
        $timeout(function () {
            if (vm.showDrop) {
                $window.document.documentElement.addEventListener('click', checkOutsideClick);
            } else {
                $window.document.documentElement.removeEventListener('click', checkOutsideClick);
            }
        });
    }

    function checkOutsideClick(event) {
        if (vm.showDrop && !isChildNode(event.target)) {
            switchDrop();
        }
    }

    function isChildNode(node) {
        return $element[0].contains(node);
    }
}

},{}],66:[function(require,module,exports){
"use strict";

angular.module('app').component('appHeader', {
    templateUrl: 'components/app-header/app-header.html',
    controller: ['$window', '$sce', 'backend', AppHeaderController],
    bindings: {
        'hideStepsSelect': '<'
    },
    controllerAs: 'vm'
});

function AppHeaderController($window, $sce, backend) {

    var vm = this;

    vm.languageChangeHandler = languageChangeHandler;
    vm.activeSection = 0;

    backend.ready.then(function () {
        var langs = backend.getParam('oxygen-check-in.allowedLanguages');

        vm.headerAliasHtml = $window.o2context.oxyNoCover ? '' : $sce.trustAsHtml(backend.getAlias('oxygen-check-in.header'));

        vm.loading = false;
        vm.availableLanguages = langs.split(',').map(function (lang) {
            var code = lang.trim();
            return {
                code: code,
                title: backend.getAlias('oxygen-check-in.langNameShort.' + code)
            };
        });
        vm.currentLanguage = $window.o2context.systemLanguage;
    });

    function languageChangeHandler(newLanguage) {
        if (vm.currentLanguage !== newLanguage) {
            $window.location = './?lang=' + newLanguage;
        }
    }
}

},{}],67:[function(require,module,exports){
"use strict";

angular.module('app').component('appLoader', {
    templateUrl: 'components/app-loader/app-loader.html',
    controller: [AppLoaderController],
    controllerAs: 'vm'
});

function AppLoaderController() {}

},{}],68:[function(require,module,exports){
"use strict";

angular.module('app').component('appModals', {
    templateUrl: 'components/app-modals/app-modals.html',
    controller: ['modalTools', '$scope', AppModalsController],
    controllerAs: 'vm'
});

function AppModalsController(modalTools, $scope) {

    var vm = this;

    vm.activeModal = false;

    modalTools.setGlobalListener(function (modalCode) {
        vm.activeModal = modalCode;
        $scope.safeApply();
    });

    $scope.safeApply = function (fn) {
        var phase = this.$root.$$phase;
        if (phase === '$apply' || phase === '$digest') {
            if (fn && typeof fn === 'function') {
                fn();
            }
        } else {
            this.$apply(fn);
        }
    };
}

},{}],69:[function(require,module,exports){
"use strict";

angular.module('app').component('buttonPopover', {
    templateUrl: 'components/button-popover/button-popover.html',
    controller: [ButtonPopoverController],
    controllerAs: 'vm',
    bindings: {
        text: '=',
        role: '@?'
    }
});

function ButtonPopoverController() {}

},{}],70:[function(require,module,exports){
"use strict";

angular.module('app').component('cartWidget', {
    templateUrl: 'components/cart-widget/cart-widget.html',
    controller: ['$scope', 'backend', '$timeout', '$window', '$element', CartWidgetController],
    controllerAs: 'vm',
    bindings: {
        'orderInfo': '<order'
    }
});

function CartWidgetController($scope, backend, $timeout, $window, $element) {

    var vm = this;

    vm.removeSelectedExtraServicesByFlight = removeSelectedExtraServicesByFlight;
    vm.removeEditableExtraServicesByPassenger = removeEditableExtraServicesByPassenger;
    vm.removeEditableExtraServicesForAllPassengers = removeEditableExtraServicesForAllPassengers;
    vm.switchDrop = switchDrop;

    vm.showFlightDetail = -1;

    $scope.$watch('vm.orderInfo', function () {
        vm.selectedExtraServicesByFlights = generateSelectedExtraServicesByFlights(vm.orderInfo.plainFlights, vm.orderInfo.editableExtraServicesHeap);
        vm.selectedExtraServicesByPassengers = generateSelectedExtraServicesByPassengers(vm.orderInfo.passengers, vm.orderInfo.editableExtraServicesHeap);
    });

    function switchDrop() {
        vm.showDrop = !vm.showDrop;
        $timeout(function () {
            if (vm.showDrop) {
                $window.document.documentElement.addEventListener('click', checkOutsideClick);
            } else {
                $window.document.documentElement.removeEventListener('click', checkOutsideClick);
            }
        });
    }

    function checkOutsideClick(event) {
        if (vm.showDrop && !isChildNode(event.target)) {
            switchDrop();
        }
    }

    function isChildNode(node) {
        return $element[0].contains(node);
    }

    function generateSelectedExtraServicesByFlights(flights, editableExtraServicesHeap) {
        return flights.map(function (flight) {
            var groupedFlightServices = [];
            (editableExtraServicesHeap || []).forEach(function (serviceItem) {
                if (serviceItem.segmentId === flight.id) {
                    var groupedFlightService = _.findWhere(groupedFlightServices, { groupCode: serviceItem.groupCode });
                    if (groupedFlightService) {
                        groupedFlightService.count = groupedFlightService.count + (serviceItem.amount || 1);
                        groupedFlightService.totalPrice = Big(groupedFlightService.totalPrice).plus(serviceItem.totalPrice || serviceItem.price).toFixed(2);
                    } else {
                        groupedFlightServices.push({
                            groupCode: serviceItem.groupCode,
                            code: serviceItem.productCode ? 'insuranceOnline' : serviceItem.groupCode,
                            totalPrice: serviceItem.totalPrice || serviceItem.price,
                            currency: serviceItem.currency,
                            count: serviceItem.amount || 1
                        });
                    }
                }
            });
            return groupedFlightServices;
        });
    }
    function generateSelectedExtraServicesByPassengers(passengers, editableExtraServicesHeap) {
        return passengers.map(function (passenger) {
            var groupedPassengerServices = [];
            (editableExtraServicesHeap || []).forEach(function (serviceItem) {
                if ((serviceItem.passengerId === passenger.id || serviceItem.firstName === passenger.firstName && serviceItem.lastName === passenger.lastName && serviceItem.dateOfBirth === passenger.dateOfBirth) && (serviceItem.segmentId === null || serviceItem.segmentId === undefined)) {
                    var groupedPassengerService = _.findWhere(groupedPassengerServices, { groupCode: serviceItem.groupCode });
                    var totalPrice = serviceItem.totalPrice || serviceItem.price || serviceItem.fare && serviceItem.fare.cost;
                    if (groupedPassengerService) {
                        groupedPassengerService.count = groupedPassengerService.count + (serviceItem.amount || 1);
                        groupedPassengerService.totalPrice = Big(groupedPassengerService.totalPrice).plus(totalPrice).toFixed(2);
                    } else {
                        groupedPassengerServices.push({
                            groupCode: serviceItem.groupCode,
                            code: serviceItem.productCode ? 'insuranceOnline' : serviceItem.groupCode,
                            totalPrice: totalPrice,
                            currency: serviceItem.currency || serviceItem.fare && serviceItem.fare.currency,
                            count: serviceItem.amount || 1
                        });
                    }
                }
            });
            return groupedPassengerServices;
        });
    }

    function removeSelectedExtraServicesByFlight(code, flightNum) {
        backend.removeExtraService({
            code: code,
            segment_id: vm.orderInfo.plainFlights[flightNum].id
        });
    }

    function removeEditableExtraServicesByPassenger(code, paxNum) {
        backend.removeExtraService({
            code: code,
            passenger_id: vm.orderInfo.passengers[paxNum].id
        });
    }

    function removeEditableExtraServicesForAllPassengers(code) {
        backend.removeExtraService({ code: code });
    }
}

},{}],71:[function(require,module,exports){
"use strict";

angular.module('app').component('checkinBackbone', {
    templateUrl: 'components/checkin-backbone/checkin-backbone.html',
    controller: ['$rootScope', CheckinBackboneController],
    controllerAs: 'vm',
    bindings: {
        locked: '<',
        selectSeat: '<',
        removeSeat: '<',
        confirm: '<',
        contacts: '<',
        extraServicesPayment: '<',
        extraServicesToRemoveIds: '=',
        orderInfo: '<order',
        es: '<',
        esList: '<',
        submitTouched: '<',
        hasNotSelectedBusinessTime: '<'
    }
});

function CheckinBackboneController($rootScope) {

    var vm = this;

    vm.confirmHandler = confirmHandler;
    vm.editPassenger = editPassenger;
    vm.savePaxData = savePaxData;
    vm.openPopupFfp = openPopupFfp;
    vm.closePopupFfp = closePopupFfp;
    vm.editablePassengerNum = -1;
    vm.editablePassengerSegmentNum = -1;
    vm.selectedSegment = vm.orderInfo.segments.length === 1 ? 0 : -1;

    vm.selectedPassengerNumBySegment = vm.orderInfo.segments.map(function () {
        return -1;
    });

    function confirmHandler() {
        if (!vm.orderInfo.hasPassengersWithoutSeat) {
            vm.confirm().catch(function (resp) {
                if (resp.error === 'check-in.contactsRequired') {
                    $rootScope.globalError = false;
                    vm.canChoosePassenger = resp.canChoosePassenger;
                    vm.phoneRequired = resp.phoneRequired;
                    vm.emailRequired = resp.emailRequired;
                    vm.showContactsRequiredPopup = true;
                }
            });
        }
    }

    function editPassenger(passengerNum, passengerSegmentNum) {
        vm.editablePassengerNum = passengerNum;
        vm.editablePassengerSegmentNum = passengerSegmentNum;
    }

    function savePaxData(data) {
        var paxDoc = vm.orderInfo.passengers[vm.editablePassengerNum].segments[vm.editablePassengerSegmentNum].document;
        paxDoc.fields.forEach(function (field) {
            if (data.document && data.document[field.name]) {
                field.value = data.document[field.name];
            }
        });
        vm.editablePassengerNum = -1;
        vm.editablePassengerSegmentNum = -1;
    }

    function openPopupFfp() {
        vm.showPopupFfp = true;
        console.log('vm.showPopupFfp: ', vm.showPopupFfp);
    }

    function closePopupFfp() {
        vm.showPopupFfp = false;
    }
}

},{}],72:[function(require,module,exports){
"use strict";

angular.module('app').component('checkinPaxOption', {
    templateUrl: 'components/checkin-pax-option/checkin-pax-option.html',
    controller: [CheckinPaxOptionController],
    controllerAs: 'vm',
    bindings: {
        passenger: '=',
        onSelect: '&',
        modifyVisa: '<',
        passengerNum: '<',
        segmentNum: '<',
        isChild: '<',
        isParentSelected: '<',
        confirmTouched: '<',
        completelyInitialized: '<',
        unavailabilityReason: '<',
        isAvailable: '<'
    }
});

function CheckinPaxOptionController() {

    var vm = this;

    vm.$onInit = function () {
        vm.passengerLabel = vm.passenger.lastName + ' ' + vm.passenger.name;
        if (vm.passenger.birthDate) {
            vm.passengerLabel += ' (' + vm.passenger.birthDate + ')';
        }
    };
}

},{}],73:[function(require,module,exports){
"use strict";

angular.module('app').component('checkinResult', {
    templateUrl: 'components/checkin-result/checkin-result.html',
    controller: ['$window', 'backend', 'redirect', 'uniqueTabIdGenerator', CheckinResultController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<order',
        selectSeat: '<',
        cancelCheckin: '<',
        successCancelMessage: '<'
    }
});

function CheckinResultController($window, backend, redirect, uniqueTabIdGenerator) {

    var vm = this;

    vm.showPopupQrClick = showPopupQrClick;
    vm.hidePopupQrClick = hidePopupQrClick;
    vm.showPopupQrAllClick = showPopupQrAllClick;
    vm.hidePopupQrAllClick = hidePopupQrAllClick;
    vm.openPopupSendBoardingPass = openPopupSendBoardingPass;
    vm.closePopupSendBoardingPass = closePopupSendBoardingPass;
    vm.clearSessionHandler = clearSessionHandler;
    vm.hidePopupCancelCheckinClick = hidePopupCancelCheckinClick;
    vm.showPopupCancelCheckinClick = showPopupCancelCheckinClick;
    vm.showPopupChangeSeatClick = showPopupChangeSeatClick;
    vm.hidePopupChangeSeatClick = hidePopupChangeSeatClick;

    vm.showPopupQrPassengerNum = -1;
    vm.showPopupQrSegmentNum = -1;

    vm.isIOS = /iPad|iPhone|iPod/.test($window.navigator.userAgent) && !$window.MSStream, vm.isAndroid = /(android)/i.test($window.navigator.userAgent), vm.$onInit = function () {
        vm.systemLanguage = o2context.systemLanguage;
        vm.tabId = uniqueTabIdGenerator();
        vm.dropState = initDropState(vm.orderInfo.segments, vm.orderInfo.passengers);
    };

    function showPopupQrClick(passengerNum, segmentNum) {
        vm.showPopupQrPassengerNum = passengerNum;
        vm.showPopupQrSegmentNum = segmentNum;
    }

    function hidePopupQrClick() {
        vm.showPopupQrPassengerNum = -1;
        vm.showPopupQrSegmentNum = -1;
    }

    function showPopupQrAllClick() {
        vm.showPopupQrAll = true;
    }

    function hidePopupQrAllClick() {
        vm.showPopupQrAll = false;
    }

    function openPopupSendBoardingPass(passengerNum) {
        vm.showPopupSendBoardingPass = true;
        vm.showPopupSendBoardingPassPassengerIndex = passengerNum;
    }

    function closePopupSendBoardingPass() {
        vm.showPopupSendBoardingPass = false;
    }

    function clearSessionHandler() {
        backend.clearSession().finally(redirect.goToSearch);
    }

    function hidePopupCancelCheckinClick() {
        vm.showPopupCancelCheckin = false;
    }

    function showPopupCancelCheckinClick(passengerNum) {
        vm.paxForCancelCheckinNum = passengerNum;
        vm.showPopupCancelCheckin = true;
    }

    function showPopupChangeSeatClick(passengerNum, segmentNum) {
        vm.passengerForChangeSeatNum = passengerNum;
        vm.segmentForChangeSeatNum = segmentNum;
        vm.showPopupChangeSeat = true;
    }

    function hidePopupChangeSeatClick() {
        vm.showPopupChangeSeat = false;
    }

    function initDropState(segments, passengers) {
        if (!segments || !segments.length || !passengers || !passengers.length) {
            return;
        } else {
            return segments.map(function () {
                return passengers.map(function () {
                    return segments.length === 1;
                });
            });
        }
    }
}

},{}],74:[function(require,module,exports){
"use strict";

angular.module('app').component('checkinRouteInfo', {
    templateUrl: 'components/checkin-route-info/checkin-route-info.html',
    controller: ['utils', CheckinRouteInfoController],
    controllerAs: 'vm',
    bindings: {
        segment: '<'
    }
});

function CheckinRouteInfoController(utils) {

    var vm = this;

    vm.checkSegmentWillBeOpened = utils.checkSegmentWillBeOpened;
}

},{}],75:[function(require,module,exports){
"use strict";

angular.module('app').component('checkinSegmentInfo', {
    templateUrl: 'components/checkin-segment-info/checkin-segment-info.html',
    controller: [CheckinSegmentInfoController],
    controllerAs: 'vm',
    bindings: {
        isCheckedin: '<',
        isSelected: '<',
        hasCheckedinPassengers: '<',
        onSelect: '&',
        segment: '<'
    }
});

function CheckinSegmentInfoController() {}

},{}],76:[function(require,module,exports){
"use strict";

angular.module('app').directive('cleanSearchOrderLastNameParam', [function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModel) {

            element.on("keydown", function (event) {
                if (event.keyCode === 32) {
                    var spaceCount = (ngModel.$modelValue || '').split(' ').length - 1;
                    if (spaceCount) {
                        event.preventDefault();
                        return false;
                    }
                }
            });

            ngModel.$parsers.push(function (input) {
                var output = (input || '').toUpperCase();
                return output;
            });
        }
    };
}]);

},{}],77:[function(require,module,exports){
"use strict";

angular.module('app').directive('cleanSearchOrderTicketParam', [function () {
    return {
        restrict: 'A',
        link: function link(scope, elem) {

            elem.on('keyup blur mouseleave', checkFormat);

            function checkFormat() {
                var value = elem.val(),
                    formatedValue = formatParam(value);
                if (value !== formatedValue) {
                    elem.val(formatedValue).trigger('change');
                }
            }

            function formatParam(value) {
                return (value || '').toUpperCase().split(' ').join('');
            }
        }
    };
}]);

},{}],78:[function(require,module,exports){
"use strict";

angular.module('app').directive('dynamicParentPadding', function () {
    return {
        link: function link(scope, element) {
            element[0].parentElement.style.paddingTop = element[0].offsetHeight + 'px';
        }
    };
});

},{}],79:[function(require,module,exports){
"use strict";

angular.module('app').component('errorMessage', {
    templateUrl: 'components/error-message/error-message.html',
    controller: ['backend', ErrorMessageController],
    controllerAs: 'vm',
    bindings: {
        control: '='
    }
});

function ErrorMessageController(backend) {

    var vm = this;
    vm.hasAlias = backend.hasAlias;
}

},{}],80:[function(require,module,exports){
"use strict";

angular.module('app').component('esAeroexpress', {
    templateUrl: 'components/es-aeroexpress/es-aeroexpress.html',
    controller: ['$window', 'backend', AeroexpressController],
    controllerAs: 'vm',
    bindings: {
        service: '=service',
        hasNotSelectedBusinessTime: '=',
        submitTouched: '<',
        orderInfo: '<order',
        locked: '<'
    }
});

function AeroexpressController($window, backend) {

    var vm = this;

    var externalStorageUrl = backend.getEnvironmentUrl('externalStorage');

    if (externalStorageUrl) {
        vm.imagesPath = externalStorageUrl + '/img/content/' + vm.service.code;
    } else {
        vm.imagesPath = $window.o2context.staticWebContentRoot + '/themes/websky/assets/static/img/content/' + vm.service.code;
    }

    vm.switchService = switchService;

    function switchService() {
        if (!vm.locked) {
            vm.service.active = !vm.service.active;
        }
    }
}

},{}],81:[function(require,module,exports){
"use strict";

angular.module('app').component('esBaggage', {
    templateUrl: 'components/es-baggage/es-baggage.html',
    controller: ['$window', 'backend', BaggageController],
    controllerAs: 'vm',
    bindings: {
        service: '=service',
        orderInfo: '<order',
        locked: '<'
    }
});

function BaggageController($window, backend) {

    var vm = this;
    var externalStorageUrl = backend.getEnvironmentUrl('externalStorage');

    if (externalStorageUrl) {
        vm.imagesPath = externalStorageUrl + '/img/content/' + vm.service.code;
    } else {
        vm.imagesPath = $window.o2context.staticWebContentRoot + '/themes/websky/assets/static/img/content/' + vm.service.code;
    }

    vm.serviceIconCode = (vm.service.iconCode || vm.service.code) + '-head-icon';

    vm.showPopupForCard = -1;

    vm.switchService = switchService;

    function switchService() {
        if (vm.service.cards.length === 1) {
            vm.showPopupForCard = 0;
        } else {
            vm.service.active = !vm.service.active;
        }
    }
}

},{}],82:[function(require,module,exports){
"use strict";

angular.module('app').component('esCommon', {
    templateUrl: 'components/es-common/es-common.html',
    controller: ['$window', 'backend', CommonController],
    controllerAs: 'vm',
    bindings: {
        service: '=service',
        orderInfo: '<order',
        locked: '<'
    }
});

function CommonController($window, backend) {

    var vm = this;
    var externalStorageUrl = backend.getEnvironmentUrl('externalStorage');

    if (externalStorageUrl) {
        vm.imagesPath = externalStorageUrl + '/img/content/' + vm.service.code;
    } else {
        vm.imagesPath = $window.o2context.staticWebContentRoot + '/themes/websky/assets/static/img/content/' + vm.service.code;
    }

    vm.serviceIconCode = (vm.service.iconCode || vm.service.code) + '-head-icon';

    vm.showPopupForCard = -1;

    vm.switchService = switchService;

    function switchService() {
        if (vm.service.bulkAdd) {
            if (!vm.locked) {
                var code = vm.service.code;

                if (vm.service.editablePrice) {
                    backend.removeExtraService({ code: code });
                } else {
                    backend.modifyExtraService({ code: code });
                }
            }
        } else if (vm.service.cards.length === 1) {
            vm.showPopupForCard = 0;
        } else {
            vm.service.active = !vm.service.active;
        }
    }
}

},{}],83:[function(require,module,exports){
"use strict";

angular.module('app').component('esInsurance', {
    templateUrl: 'components/es-insurance/es-insurance.html',
    controller: ['$window', 'backend', InsuranceController],
    controllerAs: 'vm',
    bindings: {
        service: '<',
        orderInfo: '<order',
        locked: '<'
    }
});

function InsuranceController($window, backend) {

    var vm = this;
    var externalStorageUrl = backend.getEnvironmentUrl('externalStorage');

    if (externalStorageUrl) {
        vm.imagesPath = externalStorageUrl + '/img/content';
    } else {
        vm.imagesPath = $window.o2context.staticWebContentRoot + '/themes/websky/assets/static/img/content/' + vm.service.code;
    }

    vm.serviceIconCode = (vm.service.iconCode || vm.service.code) + '-head-icon';

    vm.selectedSubgroupCode = vm.service.structure && vm.service.structure.subgroups && vm.service.structure.subgroups[0] && vm.service.structure.subgroups[0].code;

    vm.showPopupForCard = -1;

    vm.switchService = switchService;

    function switchService() {
        if (vm.service.cards.length === 1) {
            vm.showPopupForCard = 0;
        } else {
            vm.service.active = !vm.service.active;
        }
    }
}

},{}],84:[function(require,module,exports){
"use strict";

angular.module('app').component('esMeal', {
    templateUrl: 'components/es-meal/es-meal.html',
    controller: ['$window', 'backend', MealController],
    controllerAs: 'vm',
    bindings: {
        service: '=service',
        orderInfo: '<order',
        locked: '<'
    }
});

function MealController($window, backend) {

    var vm = this;
    var externalStorageUrl = backend.getEnvironmentUrl('externalStorage');

    if (externalStorageUrl) {
        vm.imagesPath = externalStorageUrl + '/img/content/' + vm.service.code;
    } else {
        vm.imagesPath = $window.o2context.staticWebContentRoot + '/themes/websky/assets/static/img/content/' + vm.service.code;
    }

    vm.serviceIconCode = (vm.service.iconCode || vm.service.code) + '-head-icon';

    vm.showPopupForCard = -1;
    vm.selectedSubgroupCode = false;

    vm.switchService = switchService;

    function switchService() {
        if (vm.service.cards.length === 1) {
            vm.showPopupForCard = 0;
        } else {
            vm.service.active = !vm.service.active;
        }
    }
}

},{}],85:[function(require,module,exports){
"use strict";

angular.module('app').component('esSeat', {
    templateUrl: 'components/es-seat/es-seat.html',
    controller: ['backend', 'utils', '$timeout', SeatController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<',
        segmentNum: '<',
        selectSeat: '<',
        removeSeat: '<',
        editPassenger: '<',
        selectedPassenger: '='
    }
});

function SeatController(backend, utils, $timeout) {

    var vm = this;
    vm.hasAlias = backend.hasAlias;
    vm.selectPassenger = selectPassenger;
    vm.seatSelectHandler = seatSelectHandler;
    vm.seatRemoveHandler = seatRemoveHandler;

    vm.$onInit = function () {
        vm.showLegendFooter = backend.hasAlias('oxygen-check-in.viewCraft.legendFooter');
        if (vm.selectedPassenger === -1) {
            selectFirstAvailablePassenger();
        } else {
            updateViewCraft();
        }
    };

    function selectPassenger(passengerNum) {
        if (vm.selectedPassenger !== passengerNum) {
            vm.selectedPassenger = passengerNum;
            updateViewCraft();
        }
    }

    function seatSelectHandler(chair) {
        if (!vm.loading) {
            if (!chair.available || chair.selected || !vm.orderInfo.passengers[vm.selectedPassenger].segments[vm.segmentNum].seatSelectAvailable) {
                return;
            }
            vm.loading = true;
            vm.selectSeat({
                segmentIndex: vm.segmentNum,
                passengerIndex: vm.selectedPassenger,
                seatNumber: chair.seatNumber,
                rfisc: chair.rfisc
            }).finally(function () {
                vm.loading = false;
                $timeout(highlightSelectedSeats);
            });
        }
    }

    function seatRemoveHandler(passengerNum) {
        if (!vm.loading) {
            vm.loading = true;
            return vm.removeSeat({
                segmentIndex: vm.segmentNum,
                passengerIndex: passengerNum,
                rfisc: vm.orderInfo.passengers[passengerNum].segments[vm.segmentNum].seat.rfisc
            }).finally(function () {
                vm.loading = false;
                $timeout(highlightSelectedSeats);
            });
        }
    }

    function selectFirstAvailablePassenger() {
        for (var i = 0; i < vm.orderInfo.passengers.length; i++) {
            selectPassenger(i);
            return;
        }
    }

    function updateViewCraft() {
        if (vm.selectedPassenger !== -1) {
            vm.loading = true;
            vm.viewCraft = false;
            backend.viewCraft(vm.segmentNum, vm.selectedPassenger).then(function (resp) {
                vm.viewCraft = reformatViewCraft(resp);
                $timeout(highlightSelectedSeats);
            }).finally(function () {
                vm.loading = false;
            });
        }
    }

    function getSeatMapLegendGroupsConfig() {
        try {
            var resultObj = JSON.parse(backend.getParam('check-in.seatMapLegendGroupsConfig'));
            return resultObj.groups || [];
        } catch (err) {
            console.log('extraServices.seatMapLegendGroupsConfig: ', err);
            return [];
        }
    }

    function reformatViewCraft(data) {

        var seatMapLegendMode = backend.getParam('check-in.seatMapLegendMode') || 'RFISC';
        var seatMapLegendGroupsConfig = getSeatMapLegendGroupsConfig();
        var legend = [];

        var getLegendIndex = function getLegendIndex(item) {
            if (seatMapLegendMode === 'CUSTOM_GROUPS' && item.customProperties && item.customProperties.legendGroup) {
                return _.findIndex(legend, function (l) {
                    return l.legendGroup.code === item.customProperties.legendGroup;
                });
            } else if (seatMapLegendMode === 'PRICE') {
                if (item.rate && item.rate.value) {
                    return _.findIndex(legend, function (l) {
                        return Number(l.cost) === Number(item.rate.value);
                    });
                } else {
                    return -1;
                }
            } else if (seatMapLegendMode === 'RFISC' && item.rfisc && item.rate && item.rate.value) {
                return _.findIndex(legend, function (l) {
                    return l.rfisc === item.rfisc;
                });
            }
            return -1;
        };

        if (data.svcs && data.svcs.length) {

            if (seatMapLegendMode === 'CUSTOM_GROUPS') {
                seatMapLegendGroupsConfig.forEach(function (legendGroup) {

                    var groupCurrency = false;
                    var groupPrice = false;
                    var minPrice = false;
                    var maxPrice = false;

                    data.svcs.forEach(function (svc) {
                        var customProperties = svc.customProperties,
                            currency = svc.currency;

                        var cost = Big(svc.cost).toFixed(2);
                        if (customProperties && customProperties.legendGroup) {
                            if (customProperties.legendGroup === legendGroup.code) {
                                if (!groupCurrency) {
                                    groupCurrency = currency;
                                }

                                if (!minPrice) {
                                    minPrice = cost;
                                } else if (Big(cost).lt(Big(minPrice))) {
                                    minPrice = cost;
                                }

                                if (!maxPrice) {
                                    maxPrice = cost;
                                } else if (Big(cost).gt(Big(maxPrice))) {
                                    maxPrice = cost;
                                }
                            }
                        }
                    });

                    if (minPrice === maxPrice) {
                        groupPrice = minPrice;
                        minPrice = false;
                        maxPrice = false;
                    }

                    if (!legendGroup.showMaxPrice) {
                        maxPrice = false;
                    }

                    var aliasCode = 'oxygen-check-in.extraServices.seatMapLegend.' + legendGroup.code;
                    legend.push({ aliasCode: aliasCode, legendGroup: legendGroup, minPrice: minPrice, maxPrice: maxPrice, cost: groupPrice, currency: groupCurrency });
                });
            } else if (seatMapLegendMode === 'PRICE') {
                data.cabins.forEach(function (cabin) {
                    if (cabin && cabin.tableRows && cabin.tableRows.length) {
                        cabin.tableRows.forEach(function (tableRow) {
                            if (tableRow.length) {
                                tableRow.forEach(function (tableCell) {
                                    if (tableCell.rate) {
                                        var currency = tableCell.rate.currencyCode;
                                        var cost = Big(tableCell.rate.value).toFixed(2);
                                        var nullCost = Big(tableCell.rate.value).eq(Big(0));
                                        if (cost && !nullCost && cost && currency && !_.findWhere(legend, { cost: cost })) {
                                            var aliasCode = 'oxygen-check-in.extraServices.seatMapLegend.' + cost + '.' + currency;
                                            legend.push({
                                                aliasCode: aliasCode,
                                                cost: cost,
                                                currency: currency
                                            });
                                        }
                                    }
                                });
                            }
                        });
                    }
                });
            } else if (seatMapLegendMode === 'RFISC') {
                data.svcs.forEach(function (svc) {
                    var rfisc = svc.rfisc;

                    if (rfisc && !_.findWhere(legend, { rfisc: rfisc })) {
                        var aliasCode = 'oxygen-check-in.extraServices.seatMapLegend.' + rfisc;
                        legend.push({
                            aliasCode: aliasCode,
                            rfisc: rfisc
                        });
                    }
                });
            }

            data.cabins.forEach(function (cabin) {
                if (cabin && cabin.tableRows && cabin.tableRows.length) {
                    cabin.tableRows.forEach(function (tableRow) {
                        if (tableRow.length) {
                            tableRow.forEach(function (tableCell) {
                                tableCell.legendIndex = getLegendIndex(tableCell);
                            });
                        }
                    });
                }
            });
        }

        data.legend = legend;

        return data;
    }

    function highlightSelectedSeats() {
        var selectedSeats = vm.orderInfo.passengers.map(function (passenger) {
            return passenger.segments[vm.segmentNum].seat && passenger.segments[vm.segmentNum].seat.number;
        }).filter(function (seatNumber) {
            return !!seatNumber;
        });
        if (vm.viewCraft && vm.viewCraft.cabins && vm.viewCraft.cabins.length) {
            vm.viewCraft.cabins.forEach(function (cabin) {
                if (cabin && cabin.places && cabin.places.length) {
                    cabin.places.forEach(function (place) {
                        if (place && place.seatNumber) {
                            place.selected = utils.hasInList(selectedSeats, place.seatNumber);
                        }
                    });
                }
            });
        }
    }
}

},{}],86:[function(require,module,exports){
"use strict";

angular.module('app').component('extraServicesList', {
    templateUrl: 'components/extra-services-list/extra-services-list.html',
    controller: ['utils', ExtraServicesListController],
    controllerAs: 'vm',
    bindings: {
        es: '=es',
        list: '=list',
        orderInfo: '<order',
        locked: '=locked',
        hasNotSelectedBusinessTime: '=',
        submitTouched: '<'
    }
});

function ExtraServicesListController(utils) {

    var vm = this;
    vm.isCommonService = utils.isCommonServiceCode;
}

},{}],87:[function(require,module,exports){
"use strict";

angular.module('app').directive('hideOnError', function () {
    return {
        link: function link(scope, element) {
            element.bind('error', function () {
                element[0].style.display = 'none';
            });
        }
    };
});

},{}],88:[function(require,module,exports){
"use strict";

require('./order-composition/orderComposition');
require('./app-loader/appLoader');
require('./smart-checkbox/smartCheckbox');
require('./smart-radiobox/smartRadiobox');
require('./error-message/errorMessage');
require('./checkin-route-info/checkinRouteInfo');
require('./popover-stages/popoverStages');
require('./checkin-pax-option/checkinPaxOption');
require('./svg-sprite-icon/svgSpriteIcon');
require('./checkin-backbone/checkinBackbone');
require('./es-seat/esSeat');
require('./view-craft/viewCraft');
require('./checkin-segment-info/checkinSegmentInfo');
require('./steps-select/stepsSelect');
require('./checkin-result/checkinResult');
require('./dynamic-parent-padding/dynamicParentPadding');
require('./extra-services-list/extraServicesList');
require('./es-meal/esMeal');
require('./es-baggage/esBaggage');
require('./es-common/esCommon');
require('./es-insurance/esInsurance');
require('./es-aeroexpress/esAeroexpress');
require('./qr-image/qrImage');
require('./app-header/appHeader');
require('./app-header-language/appHeaderLanguage');
require('./alert-message/alertMessage');
require('./passenger-item-data/passengerItemData');
require('./segment-card/segmentCard');
require('./cart-widget/cartWidget');

require('./app-modals/appModals');
require('./modal-link/modalLink');
require('./cart-widget/cartWidget');
require('./person-pax-data-editor/personPaxDataEditor');
require('./services-billing/servicesBilling');
require('./ui-select-custom/uiSelectCustom');
require('./button-popover/buttonPopover');
require('./modal-loader/modalLoader');
require('./hide-on-error/hideOnError');
require('./clean-search-order-ticket-param/cleanSearchOrderTicketParam');
require('./clean-search-order-last-name-param/cleanSearchOrderLastNameParam');

},{"./alert-message/alertMessage":64,"./app-header-language/appHeaderLanguage":65,"./app-header/appHeader":66,"./app-loader/appLoader":67,"./app-modals/appModals":68,"./button-popover/buttonPopover":69,"./cart-widget/cartWidget":70,"./checkin-backbone/checkinBackbone":71,"./checkin-pax-option/checkinPaxOption":72,"./checkin-result/checkinResult":73,"./checkin-route-info/checkinRouteInfo":74,"./checkin-segment-info/checkinSegmentInfo":75,"./clean-search-order-last-name-param/cleanSearchOrderLastNameParam":76,"./clean-search-order-ticket-param/cleanSearchOrderTicketParam":77,"./dynamic-parent-padding/dynamicParentPadding":78,"./error-message/errorMessage":79,"./es-aeroexpress/esAeroexpress":80,"./es-baggage/esBaggage":81,"./es-common/esCommon":82,"./es-insurance/esInsurance":83,"./es-meal/esMeal":84,"./es-seat/esSeat":85,"./extra-services-list/extraServicesList":86,"./hide-on-error/hideOnError":87,"./modal-link/modalLink":89,"./modal-loader/modalLoader":90,"./order-composition/orderComposition":91,"./passenger-item-data/passengerItemData":92,"./person-pax-data-editor/personPaxDataEditor":93,"./popover-stages/popoverStages":94,"./qr-image/qrImage":95,"./segment-card/segmentCard":96,"./services-billing/servicesBilling":97,"./smart-checkbox/smartCheckbox":98,"./smart-radiobox/smartRadiobox":99,"./steps-select/stepsSelect":100,"./svg-sprite-icon/svgSpriteIcon":101,"./ui-select-custom/uiSelectCustom":102,"./view-craft/viewCraft":103}],89:[function(require,module,exports){
"use strict";

angular.module('app').directive('modalLink', ['modalTools', function (modalTools) {
    return {
        restrict: 'A',
        scope: {
            modalLink: '@'
        },
        link: function link($scope, element) {
            element.bind('click', function (event) {
                event.preventDefault();
                console.log('$scope.modalLink: ', $scope.modalLink);
                modalTools.openHandler($scope.modalLink, element);
            });
        }
    };
}]);

},{}],90:[function(require,module,exports){
"use strict";

angular.module('app').directive('modalLoader', ['backend', function (backend) {

    function link(scope, element) {
        var alias = backend.getAlias('oxygen-check-in.modalLoader');
        element.html('<div class="modalLoaderWrap">' + alias + '</div>');
    }

    return {
        link: link,
        restrict: 'E',
        templateUrl: 'components/modal-loader/modal-loader.html'
    };
}]);

},{}],91:[function(require,module,exports){
"use strict";

angular.module('app').component('orderComposition', {
    templateUrl: 'components/order-composition/order-composition.html',
    controller: ['backend', '$timeout', '$scope', 'redirect', OrderCompositionController],
    controllerAs: 'vm',
    bindings: {
        addToOrder: '<',
        clearOrder: '<',
        captcha: '<?',
        updateCaptcha: '<?',
        orderInfo: '<?order'
    }
});

function OrderCompositionController(backend, $timeout, $scope, redirect) {

    var vm = this;

    vm.searchSubmitHandler = searchSubmitHandler;
    vm.addPassenger = addPassenger;
    vm.clear = clear;
    vm.paxSelectHandler = paxSelectHandler;
    vm.confirmSelectPassengers = confirmSelectPassengers;
    vm.confirmSelectSegmentsGroup = confirmSelectSegmentsGroup;

    vm.searchParams = {};

    $scope.$watch('vm.orderInfo', function (orderInfo) {
        if (orderInfo) {
            vm.showForm = false;
            vm.searchOrderAgree = true;
        } else {
            vm.showForm = true;
        }
    });

    function searchSubmitHandler() {
        if (vm.searchOrderForm.$valid && (vm.searchOrderAgree || backend.getParam('oxygen-check-in.displayConditionsFirst') || !backend.getParam('oxygen-check-in.showSearchAgreeCheckbox'))) {
            vm.loading = true;
            vm.addToOrder(vm.searchParams);
        }
    }

    function confirmSelectSegmentsGroup(segmentsGroupIndex) {
        vm.searchParams.segmentsGroupIndex = segmentsGroupIndex;
        searchSubmitHandler();
    }

    function addPassenger() {
        vm.searchParams = {};
        vm.showForm = true;
    }

    function clear() {
        vm.searchParams = {};
        vm.showForm = true;
        vm.orderInfo = false;
        vm.errorMessage = false;
        vm.clearOrder();
        backend.clearSession();
    }

    function paxSelectHandler(passengerNum) {
        var newState = !vm.orderInfo.passengers[passengerNum].selected;
        if (!newState && isLastSelectedPassenger()) {
            $timeout(function () {
                vm.orderInfo.passengers[passengerNum].selected = true;
            });
            return;
        }
        backend.changePassengerSelection(passengerNum, newState);
    }

    function isLastSelectedPassenger() {
        return vm.orderInfo.passengers.filter(function (pax) {
            return pax.selected;
        }).length === 1;
    }

    function confirmSelectPassengers() {
        vm.confirmTouched = true;
        if (vm.orderInfo.hasOpenedSegments && vm.orderInfo.hasAvailablePassengers) {
            if (vm.orderInfo.completelyInitialized) {
                goToNextStep();
            } else {
                vm.loading = true;
                backend.confirmPassengersSelection({
                    passengers: vm.orderInfo.passengers.map(function (passenger) {
                        return passenger.selected;
                    })
                }).then(goToNextStep).finally(function () {
                    vm.loading = false;
                });
            }
        }
    }

    function goToNextStep() {
        if (vm.orderInfo.passengersType === 'CHECKED') {
            redirect.goToBoardingPass();
        } else {
            redirect.goToCheckIn();
        }
    }
}

},{}],92:[function(require,module,exports){
"use strict";

angular.module('app').component('passengerItemData', {
    templateUrl: 'components/passenger-item-data/passenger-item-data.html',
    controller: ['backend', PassengerItemDataController],
    controllerAs: 'vm',
    bindings: {
        passenger: '<',
        segNum: '<',
        isChild: '<',
        isParentSelected: '<'
    }
});

function PassengerItemDataController(backend) {

    var vm = this;

    vm.getCountryNameByCode = backend.getCountryNameByCode;
}

},{}],93:[function(require,module,exports){
"use strict";

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').component('personPaxDataEditor', {
    templateUrl: 'components/person-pax-data-editor/person-pax-data-editor.html',
    controller: ['$scope', '$timeout', 'backend', PersonPaxDataEditorController],
    controllerAs: 'vm',
    bindings: {
        paxNum: '<',
        segNum: '<',
        paxData: '=',
        mode: '<',
        isChild: '<'
    }
});

function PersonPaxDataEditorController($scope, $timeout, backend) {

    var vm = this;
    var todayMoment = moment(o2context.serverDateTime);

    vm.submitHandler = submitHandler;
    vm.hideDatePicker = hideDatePicker;
    vm.showDatePicker = showDatePicker;

    vm.datePickerActive = {};

    vm.aliasCodeByFieldName = {
        document: {
            'type': 'documentType',
            'issueCountry': 'documentIssueCountry',
            'number': 'documentNumber',
            'nationality': 'nationality',
            'birthDate': 'documentBirthDate',
            'gender': 'documentGender',
            'expirationDate': 'documentExpirationDate'
        },
        visa: {
            'birthPlace': 'visaBirthPlace',
            'number': 'visaNumber',
            'issueCity': 'visaIssueCity',
            'issueCountry': 'visaIssueCountry',
            'issueDate': 'visaIssueDate',
            'expirationDate': 'visaExpirationDate',
            'hostCountry': 'visaHostCountry'
        },
        ffpCard: {
            'ffpCardNumber': 'ffpCardNumber'
        }
    };

    $scope.$watch('vm.editorState', function (newEditorState) {
        vm.hasChanges = JSON.stringify(newEditorState) !== JSON.stringify(vm.editorInitState);
    }, true);
    $scope.$watch('vm.paxData', function (newPaxData) {
        var documentState = {};
        var visaState = {};
        newPaxData.document.fields.forEach(function (field) {
            field.type = 'text';
            if (field.name === 'type') {
                field.options = backend.getDocumentTypesList().map(function (code) {
                    return {
                        code: code,
                        value: backend.getAlias('oxygen-check-in.documentType.' + code)
                    };
                });
                if (field.options.length === 1) {
                    field.value = field.options[0].code;
                }
                field.type = 'select';
            }
            if (field.name === 'gender') {
                field.options = [{ code: 'M', value: backend.getAlias('oxygen-check-in.gender.M') }, { code: 'F', value: backend.getAlias('oxygen-check-in.gender.F') }];
                field.type = 'select';
            }
            if (field.name === 'nationality' || field.name === 'issueCountry') {
                field.options = backend.getCountriesList();
                field.type = 'select';
            }
            if (field.name === 'number') {
                field.pattern = newPaxData.document.isInternational ? backend.applicationConstants.documentNumberLatRegexp : backend.applicationConstants.documentNumberRegexp;
            }
            if (field.name === 'birthDate' || field.name === 'expirationDate') {
                field.type = 'date';
                if (field.name === 'birthDate') {
                    field.maxDate = todayMoment;
                }
                if (field.name === 'expirationDate') {
                    field.minDate = todayMoment;
                }
            }
            documentState[field.name] = field.value;
        });
        newPaxData.visa.fields.forEach(function (field) {
            field.type = 'text';
            if (field.name === 'hostCountry' || field.name === 'issueCountry') {
                field.options = backend.getCountriesList();
                field.type = 'select';
            }
            visaState[field.name] = field.value;

            if (field.name === 'birthPlace') {
                field.pattern = newPaxData.visa.isInternational ? backend.applicationConstants.visaBirthPlaceLatRegexp : backend.applicationConstants.visaBirthPlaceRegexp;
            }
            if (field.name === 'number') {
                field.pattern = newPaxData.visa.isInternational ? backend.applicationConstants.visaNumberLatRegexp : backend.applicationConstants.visaNumberRegexp;
            }
            if (field.name === 'issueCity') {
                field.pattern = newPaxData.visa.isInternational ? backend.applicationConstants.visaIssueCityLatRegexp : backend.applicationConstants.visaIssueCityRegexp;
            }
            if (field.name === 'issueDate' || field.name === 'expirationDate') {
                field.type = 'date';
                if (field.name === 'issueDate') {
                    field.maxDate = todayMoment;
                }
                if (field.name === 'expirationDate') {
                    field.minDate = todayMoment;
                }
            }
        });

        vm.editorState = {
            document: documentState,
            visa: visaState
        };
        if (backend.getParam('oxygen-check-in.workWithFFP')) {
            vm.editorState.ffpCard = {
                ffpCardNumber: newPaxData.ffpCardNumber || ''
            };
        }
        if (!vm.editorInitState) {
            vm.editorInitState = angular.copy(vm.editorState);
        }
    });

    function submitHandler() {
        if (vm.editorForm.$valid) {
            var reqParams = {
                passengerIndex: vm.paxNum,
                segmentIndex: vm.segNum
            };
            var paxData = (0, _extends3.default)({}, vm.editorState);
            if (paxData && paxData.ffpCard && paxData.ffpCard.ffpCardNumber) {
                paxData.ffpCardNumber = paxData.ffpCard.ffpCardNumber;
                delete paxData.ffpCard;
            }

            reqParams[vm.isChild ? 'passengerChildData' : 'passengerData'] = JSON.stringify(paxData);
            vm.loading = true;
            vm.errorMessage = false;
            return backend.modifyDataSeat(reqParams).then(function () {
                vm.paxData.visa.fields.forEach(function (field) {
                    field.value = vm.editorState.visa[field.name];
                });
                vm.paxData.visa.fields.forEach(function (field) {
                    field.value = vm.editorState.visa[field.name];
                });
                vm.showSaveSuccessMessage = true;
                $timeout(function () {
                    vm.showSaveSuccessMessage = false;
                }, 5000);
                vm.loading = false;
            }, function (resp) {
                vm.errorMessage = resp.error;
                vm.loading = false;
            });
        }
    }

    function hideDatePicker(name) {
        vm.datePickerActive[name] = false;
    }

    function showDatePicker(name) {
        vm.datePickerActive[name] = true;
    }
}

},{"babel-runtime/helpers/extends":3}],94:[function(require,module,exports){
"use strict";

angular.module('app').component('popoverStages', {
    templateUrl: 'components/popover-stages/popover-stages.html',
    controller: ['$timeout', '$element', '$window', PopoverStagesController],
    controllerAs: 'vm',
    bindings: {
        stages: '='
    }
});

function PopoverStagesController($timeout, $element, $window) {

    var vm = this;

    vm.switchState = switchState;

    vm.active = false;

    function switchState() {
        vm.active = !vm.active;
        $timeout(function () {
            if (vm.active) {
                $window.document.documentElement.addEventListener('click', checkOutsideClick);
            } else {
                $window.document.documentElement.removeEventListener('click', checkOutsideClick);
            }
        });
    }

    function checkOutsideClick(event) {
        if (vm.active && !isChildNode(event.target)) {
            switchState();
        }
    }

    function isChildNode(node) {
        return $element[0].contains(node);
    }
}

},{}],95:[function(require,module,exports){
"use strict";

angular.module('app').component('qrImage', {
    templateUrl: 'components/qr-image/qr-image.html',
    controller: ['uniqueTabIdGenerator', QrImageController],
    controllerAs: 'vm',
    bindings: {
        flight: '<',
        flightNum: '<',
        passenger: '<',
        passengerNum: '<',
        isChild: '<'
    }
});

function QrImageController(uniqueTabIdGenerator) {

    var vm = this;

    vm.$onInit = function () {
        var tabId = uniqueTabIdGenerator();
        vm.imageUrl = './qr/qr.png?tabId=' + tabId + '&segmentIndex=' + vm.flightNum + '&passengerIndex=' + vm.passengerNum + '&forChild=' + !!vm.isChild;
    };
}

},{}],96:[function(require,module,exports){
"use strict";

angular.module('app').component('segmentCard', {
    templateUrl: 'components/segment-card/segment-card.html',
    controller: [SegmentCardController],
    controllerAs: 'vm',
    bindings: {
        segment: '<',
        segmentNum: '<?',
        through: '<?'
    }
});

function SegmentCardController() {}

},{}],97:[function(require,module,exports){
"use strict";

angular.module('app').component('servicesBilling', {
    templateUrl: 'components/services-billing/services-billing.html',
    controller: ['utils', '$scope', 'backend', ServicesBillingController],
    controllerAs: 'vm',
    bindings: {
        mode: '@mode',
        orderInfo: '=order'
    }
});

function ServicesBillingController(utils, $scope, backend) {

    var vm = this;

    vm.$onInit = function () {
        if (vm.mode === 'editable') {
            $scope.$watch('vm.orderInfo.sirenaOrder.groupedEditableExtraServices', updateGroupCards);
            $scope.$watch('vm.orderInfo.passengers', updateSeatCard);
        } else if (vm.mode === 'all') {
            $scope.$watch('vm.orderInfo.sirenaOrder.groupedAllExtraServices', updateGroupCards);
            $scope.$watch('vm.orderInfo.passengers', updateSeatCard);
        }
    };

    function updateGroupCards(groupedServices) {

        var groupCards = [];
        var definedOrder = Object.keys(groupedServices);
        if (groupedServices) {

            definedOrder.forEach(function (code) {
                var groupCard = {
                    code: code
                };

                // if (groupedServices[groupCard.code]) {

                // if (groupCard.code === 'aeroexpress') {
                //     const orderAE = _.findWhere(
                //         vm.orderInfo.sirenaOrder.allExtraServices,
                //         { code: 'aeroexpress' }
                //     );
                //     if (orderAE && orderAE.items) {
                //         groupCard.plainServices = generatePlainAeroexpressList(orderAE.items);
                //     }
                // } else {

                groupCard.passengers = [];
                groupedServices[groupCard.code].forEach(function (paxServices, paxNum) {
                    if (paxServices) {
                        var flights = generateCardFlights(paxServices, groupCard.code);
                        if (flights.length) {
                            groupCard.passengers.push({
                                lastName: vm.orderInfo.sirenaOrder.passengers[paxNum].lastName,
                                firstName: vm.orderInfo.sirenaOrder.passengers[paxNum].firstName,
                                flights: flights
                            });
                        }
                    }
                });

                // }

                var pricesData = false;
                if (vm.mode === 'all') {
                    pricesData = vm.orderInfo.sirenaOrder.pricesIssued;
                } else if (vm.mode === 'editable') {
                    pricesData = vm.orderInfo.sirenaOrder.pricesNotIssued;
                }

                if (pricesData && pricesData.totalExtraServiceByGroup && pricesData.totalExtraServiceByGroup[groupCard.code]) {
                    groupCard.price = pricesData.totalExtraServiceByGroup[groupCard.code];
                    groupCard.currency = pricesData.currency;
                }
                if (groupCard.price) {
                    groupCards.push(groupCard);
                }
                // }
            });
        }

        vm.groupCards = groupCards;
    }

    function updateSeatCard(orderPassengers) {
        var seatCard = { code: 'seat' };
        if (vm.orderInfo.astraSeatTotalNotPaidPrice) {
            seatCard.price = vm.orderInfo.astraSeatTotalNotPaidPrice;
            seatCard.currency = vm.orderInfo.astraSeatTotalCurrency;
        }
        if (orderPassengers && orderPassengers.length) {
            seatCard.passengers = [];
            orderPassengers.forEach(function (pax) {
                var hasPaxSeats = false;
                var flights = vm.orderInfo.segments.map(function (orderSeg, orderSegNum) {
                    var flight = false;
                    var seat = pax.segments[orderSegNum].seat;
                    if (seat) {
                        hasPaxSeats = true;
                        flight = {
                            route: {
                                originCityName: orderSeg.departureCity,
                                destinationCityName: orderSeg.arrivalCity
                            },
                            services: [{
                                currency: seat.currency,
                                price: seat.cost,
                                issued: seat.paid,
                                label: generateServiceLabel({ value: seat.number }, 'seat')
                            }]
                        };
                    }
                    return flight;
                });
                if (hasPaxSeats) {
                    seatCard.passengers.push({
                        lastName: pax.lastName,
                        firstName: pax.name,
                        flights: flights
                    });
                }
            });
        }

        if (!vm.groupCards) {
            vm.groupCards = [];
        }
        var seatIndex = _.findIndex(vm.groupCards, { code: 'seat' });
        if (seatCard.passengers.length) {
            if (seatIndex === -1) {
                vm.groupCards.unshift(angular.copy(seatCard));
            } else {
                vm.groupCards[seatIndex] = angular.copy(seatCard);
            }
        }
    }

    function generateCardFlights(flightsServices, groupCode) {
        var flights = [];
        flightsServices.forEach(function (flightServices, flightNum) {
            if (flightServices) {
                if (groupCode !== 'aeroexpress') {
                    flights.push({
                        route: vm.orderInfo.sirenaOrder.plainFlights[flightNum],
                        services: flightServices.map(function (service) {
                            return {
                                currency: service.currency,
                                price: service.totalPrice || service.price,
                                issued: checkIssued(service),
                                label: generateServiceLabel(service, groupCode)
                            };
                        })
                    });
                }
            }
        });
        return flights;
    }
    /*
        function generatePlainAeroexpressList(items) {
            const orderByFare = ['full', 'child', 'business'];
            const result = [];
    
            items.forEach((item) => {
                const filterObj = (item.fare.fare_type === 'business') ? {
                    departure_date: item.departure_date,
                    departure_time: item.departure_time,
                    fare_type: item.fare.fare_type,
                    status: item.status,
                    arrival_code: item.arrival_code,
                    departure_code: item.departure_code,
                } : {
                    fare_type: item.fare.fare_type,
                    status: item.status,
                };
    
                const targetItem = _.findWhere(result, filterObj);
                if (!targetItem) {
                    result.push({
                        ...item,
                        fare_type: item.fare.fare_type,
                        price: item.fare.cost,
                        currency: item.fare.currency,
                        issued: checkIssued(item),
                        count: 1,
                    });
                } else {
                    targetItem.count += 1;
                    targetItem.price = Big(targetItem.price).plus(item.fare.cost).toFixed(2);
                }
            });
    
            return result.map((item) => ({
                label: generateAeroexpressServiceLabel(item),
                ...item
            })).sort(
                (a, b) => {
                    if (a.status !== b.status) {
                        if (a.status === 'ISSUED') {
                            return 1;
                        } else if (b.status === 'ISSUED') {
                            return -1;
                        }
                    } else {
                        const fareIndexA = orderByFare.indexOf(a.fare_type);
                        const fareIndexB = orderByFare.indexOf(b.fare_type);
                        if (fareIndexA > fareIndexB) {
                            return 1;
                        } else if (fareIndexA < fareIndexB) {
                            return -1;
                        } else if (a.fare_type === 'business') {
                            let result = utils.compareStringDate(a.departure_date, b.departure_date);
                            if (result === 0) {
                                result = utils.compareStringTime(a.departure_time, b.departure_time);
                            }
                            return result;
                        } else {
                            return 0;
                        }
                    }
                }
            );
        }
        */
    function checkIssued(service) {
        return service.status === 'ISSUED_WITH_EMD' || service.status === 'ISSUED';
    }
    /*
        function generateAeroexpressServiceLabel(service) {
            let aeLabel = `${backend.getAlias('oxygen-check-in.extraServices.aeroexpress.label.selectedFare')} "${backend.getAliasWithPrefix('oxygen-check-in.extraServices.aeroexpress.fareName.', service.fare.fare_type)}"`;
            if (service.fare.fare_type === 'business') {
                aeLabel += `, ${service.departure_date} ${service.departure_time}`;
            }
            aeLabel += `&nbsp; ${service.count}&nbsp;${backend.getAlias('oxygen-check-in.extraServices.aeroexpress.label.pc')}`;
            return aeLabel;
        }
    */
    function generateServiceLabel(service, groupCode) {
        switch (groupCode) {
            case 'insurance':
                {
                    if (service.productCode) {
                        return backend.getAlias('oxygen-check-in.insuranceOnline.' + service.ins + '.' + service.tins + '.' + service.productCode);
                    } else {
                        return backend.getAlias('oxygen-check-in.insuranceOnline.' + service.ins + '.' + service.tins);
                    }
                }
            case 'seat':
                {
                    return backend.getAlias('oxygen-check-in.orderInfo.extraServices.seat') + ' ' + (service.value || '');
                }
            default:
                {
                    return service.title + ' x' + service.amount;
                }
        }
    }
}

},{}],98:[function(require,module,exports){
"use strict";

angular.module('app').component('smartCheckbox', {
    templateUrl: 'components/smart-checkbox/smart-checkbox.html',
    controller: [function () {}],
    controllerAs: 'vm',
    bindings: {
        label: '<',
        icon: '<',
        checked: '=',
        disabled: '<',
        changeHandler: '<'
    }
});

},{}],99:[function(require,module,exports){
"use strict";

angular.module('app').component('smartRadiobox', {
    templateUrl: 'components/smart-radiobox/smart-radiobox.html',
    controller: [function () {}],
    controllerAs: 'vm',
    bindings: {
        options: '<',
        valueProp: '@',
        nameProp: '@',
        selected: '=',
        selectHandler: '<'
    }
});

},{}],100:[function(require,module,exports){
"use strict";

angular.module('app').component('stepsSelect', {
    templateUrl: 'components/steps-select/steps-select.html',
    controller: ['$location', 'ROUTES', 'backend', StepsSelectController],
    controllerAs: 'vm',
    bindings: {}
});

function StepsSelectController($location, ROUTES, backend) {

    var vm = this;

    vm.stepsList = generateSteps();
    vm.handleClick = handleClick;

    function generateSteps() {
        var steps = [{
            url: ROUTES.SEARCH,
            title: backend.getAlias('oxygen-check-in.steps.search')
        }, {
            url: ROUTES.CHECK_IN,
            title: backend.getAlias('oxygen-check-in.steps.checkIn')
        }, {
            url: ROUTES.BOARDING_PASS,
            title: backend.getAlias('oxygen-check-in.steps.boardingPass')
        }];
        steps.forEach(function (step) {
            if ($location.path().indexOf(step.url) !== -1 || $location.path().indexOf(step.alternativeUrl) !== -1) {
                step.active = true;
            } else {
                step.disabled = true;
            }
        });
        return steps;
    }

    function handleClick(step) {
        if (!step.active && !step.disabled) {
            $location.path(step.url);
        }
    }
}

},{}],101:[function(require,module,exports){
"use strict";

angular.module('app').component('svgSpriteIcon', {
    templateUrl: 'components/svg-sprite-icon/svg-sprite-icon.html',
    controller: ['$sce', SvgIconController],
    controllerAs: 'vm',
    bindings: {
        code: '@',
        prefix: '@'
    }
});

function SvgIconController($sce) {

    var vm = this;

    vm.$onInit = function () {
        vm.svgTag = generateSvgTag();
    };

    function generateSvgTag() {
        // I use dirty solution because IE11
        return $sce.trustAsHtml('\n            <svg class="svg-sprite-icon svg-' + vm.code + ' ' + (vm.prefix || '') + '">\n                <use xlink:href="#' + vm.code + '"></use>\n            </svg>\n        ');
    }
}

},{}],102:[function(require,module,exports){
"use strict";

angular.module('app').directive('uiSelectCustom', ['$timeout', function ($timeout) {
    return {
        require: 'uiSelect',
        restrict: 'A',
        link: function link($scope, element, attrs, ctrl) {

            /**
             * Смена елемента по табуляции
             */
            changeElementByTabEvent();

            function changeElementByTabEvent() {
                var autoopen = true;

                angular.element(ctrl.focusser).on('focus', function () {
                    if (autoopen) {
                        ctrl.activate();
                    }
                });

                //Дизейблим autoopen, когда выбранный элемент активирован
                $scope.$on('uis:activate', function () {
                    autoopen = false;
                });

                $scope.$on('uis:close', function () {
                    //Чтобы focusser после закрытия не выполнял re-activate
                    autoopen = false;
                    //250ms специально для IE
                    $timeout(function () {
                        autoopen = true;
                    }, 250);
                });
            }
        }
    };
}]);

},{}],103:[function(require,module,exports){
"use strict";

angular.module('app').component('viewCraft', {
    templateUrl: 'components/view-craft/view-craft.html',
    controller: ['$window', '$timeout', SeatMapController],
    controllerAs: 'vm',
    bindings: {
        cabins: '<',
        locked: '<',
        seatSelect: '<select',
        selectedSeat: '<'
    }
});

function SeatMapController($window, $timeout) {

    var vm = this;

    vm.isRowWithExit = isRowWithExit;
    vm.seatClickHandler = seatClickHandler;
    vm.hoverRow = -1;
    vm.hoverCell = -1;
    vm.hoverCabin = -1;

    $window.document.documentElement.addEventListener('click', checkOutsideClick);

    function isRowWithExit(seats) {
        return seats.some(function (seat) {
            return seat.type === 'SEAT_NEAR_EMERGENCY_EXIT';
        });
    }

    function seatClickHandler(cellNum, rowNum, cabinNum) {
        vm.hoverRow = rowNum;
        vm.hoverCell = cellNum;
        vm.hoverCabin = cabinNum;
    }

    function checkOutsideClick(event) {
        if (event.target.className !== 'view-craft__seat-name') {
            $timeout(function () {
                vm.hoverRow = -1;
                vm.hoverCell = -1;
                vm.hoverCabin = -1;
            });
        }
    }
}

},{}],104:[function(require,module,exports){
"use strict";

var momentLang = o2context.systemLanguage;

if (momentLang === 'hy') {
    momentLang = 'hy-am';
}

moment.locale(momentLang);

moment.updateLocale(momentLang, { week: { dow: 1, doy: 4 } });

angular.module('app').config(['momentPickerProvider', function (momentPickerProvider) {

    if (momentLang === 'ru') {
        moment.updateLocale('ru', {
            months: {
                format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
                standalone: 'Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split('_')
            }
        });
    }

    momentPickerProvider.options({
        locale: momentLang,
        format: 'DD.MM.YYYY',
        startView: 'decade',
        today: false,
        keyboard: true,
        autoclose: true,
        leftArrow: '<div class="datepicker-arrow datepicker-arrow_left"><svg><use xlink:href="#arrow-left"></use></svg></div>',
        rightArrow: '<div class="datepicker-arrow datepicker-arrow_right"><svg><use xlink:href="#arrow-right"></use></svg></div>'
    });
}]);

},{}],105:[function(require,module,exports){
"use strict";

angular.module('app').filter('alias', ['backend', function (backend) {
    return backend.getAlias;
}]);

},{}],106:[function(require,module,exports){
"use strict";

angular.module('app').filter('checkCustomErrorEmailHighlight', function () {
    return function (control) {
        return control.$touched && (control.$error.required || control.$error.pattern || control.$error.email) || control.$dirty && (control.$error.required || control.$error.checkEmailLax);
    };
});

},{}],107:[function(require,module,exports){
"use strict";

angular.module('app').filter('cropToInitials', function () {
    return function (fullName) {
        return (fullName || '').trim().split(' ').map(function (word) {
            return word[0].toUpperCase() + '.';
        }).join('');
    };
});

},{}],108:[function(require,module,exports){
"use strict";

angular.module('app').filter('formatDate', function () {
    return function (input, formatDate) {
        return moment(input, 'DD.MM.YYYY').format(formatDate);
    };
});

},{}],109:[function(require,module,exports){
"use strict";

require('./alias');
require('./param');
require('./price');
require('./formatDate');
require('./sortByCost');
require('./cropToInitials');
require('./checkCustomErrorEmailHighlight');

},{"./alias":105,"./checkCustomErrorEmailHighlight":106,"./cropToInitials":107,"./formatDate":108,"./param":110,"./price":111,"./sortByCost":112}],110:[function(require,module,exports){
"use strict";

angular.module('app').filter('param', ['backend', function (backend) {
    return backend.getParam;
}]);

},{}],111:[function(require,module,exports){
"use strict";

angular.module('app').filter('price', ['utils', function (utils) {
    return utils.formatPrice;
}]);

},{}],112:[function(require,module,exports){
"use strict";

angular.module('app').filter('sortByCost', function () {
    return function (list) {
        return list.sort(function (a, b) {
            var A = Big(a.cost);
            var B = Big(b.cost);
            if (A.gt(B)) {
                return 1;
            } else if (A.lt(B)) {
                return -1;
            } else {
                return 0;
            }
        });
    };
});

},{}],113:[function(require,module,exports){
"use strict";
// jscs:disable

angular.module('app').config(['$httpProvider', function ($httpProvider) {

    $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

    /**
    * The workhorse; converts an object to x-www-form-urlencoded serialization.
    * @param {Object} obj
    * @return {String}
    */
    function param(obj) {
        var query = '',
            name = void 0,
            value = void 0,
            fullSubName = void 0,
            subName = void 0,
            subValue = void 0,
            innerObj = void 0,
            i = void 0;

        for (name in obj) {
            value = obj[name];

            if (value instanceof Array) {
                for (i = 0; i < value.length; ++i) {
                    subValue = value[i];
                    fullSubName = name + '[' + i + ']';
                    innerObj = {};
                    innerObj[fullSubName] = subValue;
                    query += param(innerObj) + '&';
                }
            } else if (value instanceof Object) {
                for (subName in value) {
                    subValue = value[subName];
                    fullSubName = name + '[' + subName + ']';
                    innerObj = {};
                    innerObj[fullSubName] = subValue;
                    query += param(innerObj) + '&';
                }
            } else if (value !== undefined && value !== null) {
                query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
            }
        }

        return query.length ? query.substr(0, query.length - 1) : query;
    }

    // Override $http service's default transformRequest
    $httpProvider.defaults.transformRequest = [function (data) {
        return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
    }];
}]);

},{}],114:[function(require,module,exports){
"use strict";

require('./popup-custom-error/popupCustomError');
require('./popup-confirm-checkin/popupConfirmCheckin');
require('./popup-error/popupError');
require('./popup-cancel-checkin/popupCancelCheckin');
require('./popup-select-segments/popupSelectSegments');
require('./popup-meal/popupMeal');
require('./popup-baggage/popupBaggage');
require('./popup-common-service/popupCommonService');
require('./popup-qr-all/popupQrAll');
require('./popup-qr/popupQr');
require('./popup-send-boarding-pass/popupSendBoardingPass');
require('./popup-pax-data-editor/popupPaxDataEditor');
require('./popup-pax-visa-editor/popupPaxVisaEditor');
require('./popup-change-seat/popupChangeSeat');
require('./popup-insurance/popupInsurance');
require('./popup-select-segments-group/popupSelectSegmentsGroup');
require('./popup-alias/popupAlias');
require('./popup-select-segments-group/popupSelectSegmentsGroup');
require('./popup-ae-service/popupAeService');
require('./popup-removed-services-warning/popupRemovedServicesWarning');
require('./popup-select-segments-type/popupSelectSegmentsType');
require('./popup-conditions/popupConditions');
require('./popup-ffp/popupFfp');

},{"./popup-ae-service/popupAeService":115,"./popup-alias/popupAlias":116,"./popup-baggage/popupBaggage":117,"./popup-cancel-checkin/popupCancelCheckin":118,"./popup-change-seat/popupChangeSeat":119,"./popup-common-service/popupCommonService":120,"./popup-conditions/popupConditions":121,"./popup-confirm-checkin/popupConfirmCheckin":122,"./popup-custom-error/popupCustomError":123,"./popup-error/popupError":124,"./popup-ffp/popupFfp":125,"./popup-insurance/popupInsurance":126,"./popup-meal/popupMeal":127,"./popup-pax-data-editor/popupPaxDataEditor":128,"./popup-pax-visa-editor/popupPaxVisaEditor":129,"./popup-qr-all/popupQrAll":130,"./popup-qr/popupQr":131,"./popup-removed-services-warning/popupRemovedServicesWarning":132,"./popup-select-segments-group/popupSelectSegmentsGroup":133,"./popup-select-segments-type/popupSelectSegmentsType":134,"./popup-select-segments/popupSelectSegments":135,"./popup-send-boarding-pass/popupSendBoardingPass":136}],115:[function(require,module,exports){
"use strict";

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').component('popupAeService', {
    templateUrl: 'modals/popup-ae-service/popup-ae-service.html',
    controller: ['$scope', '$timeout', 'backend', 'utils', PopupAeServiceController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<order',
        imagesPath: '<',
        items: '<',
        ticketCountLimit: '<',
        autoSelectByOpen: '<',
        autoSelectMinAge: '<',
        onClose: '&',
        locked: '<'
    }
});

function PopupAeServiceController($scope, $timeout, backend, utils) {

    var vm = this;
    vm.closeHandler = closeHandler;
    vm.serviceCountChangeHandler = serviceCountChangeHandler;
    vm.changeDateHandler = changeDateHandler;

    vm.$onInit = function () {

        cardDataUpdate();

        var viewedServicesItems = utils.getViewedServicesItems();
        var hasBeenViewed = utils.hasInList(viewedServicesItems, 'aeroexpress');

        utils.addViewedServiceItem('aeroexpress');

        if (vm.autoSelectByOpen && !hasBeenViewed) {

            var autoSelectItemsParams = [];

            vm.availableAeByFareRoutesList.forEach(function (availableAeItem, index) {
                if (availableAeItem.selectedDate && !availableAeItem.dateVariants[availableAeItem.selectedDate].alreadySelectedCount) {
                    var aeMoment = moment(availableAeItem.selectedDate, 'DD.MM.YYYY');
                    var paxListForDate = vm.orderInfo.passengers.filter(function (pax) {
                        var yearsDiff = aeMoment.diff(moment(pax.dateOfBirth, 'DD.MM.YYYY'), 'years', false);
                        return yearsDiff >= vm.autoSelectMinAge;
                    });
                    autoSelectItemsParams.push({
                        index: index,
                        count: paxListForDate.length > vm.ticketCountLimit ? vm.ticketCountLimit : paxListForDate.length
                    });
                }
            });

            if (autoSelectItemsParams.length) {
                vm.autoSelectLoader = true;
                $timeout(function () {
                    var queue = false;
                    autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params.index, params.count, !isLast);
                        } else {
                            queue = queue.then(function () {
                                return serviceCountChangeHandler(params.index, params.count, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        }
    };

    $scope.$watchGroup(['vm.card', 'vm.orderInfo'], cardDataUpdate);

    function changeDateHandler(item, index) {
        var dateVariants = item.dateVariants,
            dateVariantsList = item.dateVariantsList,
            selectedDate = item.selectedDate;


        var reqParamsList = [];

        var tmpSelectedCount = 0;

        dateVariantsList.forEach(function (dateVariantCode) {
            var dateVariant = dateVariants[dateVariantCode];
            var date = dateVariant.date;

            if (dateVariant.alreadySelectedCount && date !== selectedDate) {
                tmpSelectedCount = dateVariant.alreadySelectedCount;
                reqParamsList.push((0, _extends3.default)({}, item, {
                    selectedDate: date
                }));
            }
        });

        if (reqParamsList.length && tmpSelectedCount) {
            vm.autoRemoveLoader = true;
            var queue = false;
            reqParamsList.forEach(function (params) {
                if (!queue) {
                    queue = serviceClearHandler(params, false);
                } else {
                    queue = queue.then(function () {
                        return serviceClearHandler(params, true);
                    });
                }
            });
            queue = queue.then(function () {
                vm.autoRemoveLoader = false;
                vm.autoSelectLoader = true;
                return serviceCountChangeHandler(index, tmpSelectedCount, false, true);
            });
            queue.finally(function () {
                vm.autoSelectLoader = false;
            });
        }
    }

    function cardDataUpdate() {

        var availableAeByFareRoutes = {};

        vm.items.forEach(function (item) {
            var fare = item.fare,
                departure_code = item.departure_code,
                arrival_code = item.arrival_code,
                date = item.date,
                cost = item.cost,
                currency = item.currency,
                preferredDate = item.preferredDate;


            var fareRouteCode = departure_code + '_' + arrival_code + '_' + fare;

            var orderAeItems = getOrderAeItemsByParams(fare, date, departure_code, arrival_code);

            if (!availableAeByFareRoutes[fareRouteCode]) {
                var dateVariants = {};
                dateVariants[date] = {
                    date: date,
                    cost: cost,
                    currency: currency,
                    preferredDate: preferredDate,
                    alreadySelectedCount: orderAeItems.length
                };
                availableAeByFareRoutes[fareRouteCode] = {
                    fare: fare,
                    departure_code: departure_code,
                    arrival_code: arrival_code,
                    dateVariants: dateVariants
                };
            } else {
                availableAeByFareRoutes[fareRouteCode].dateVariants[date] = {
                    date: date,
                    cost: cost,
                    currency: currency,
                    preferredDate: preferredDate,
                    alreadySelectedCount: orderAeItems.length
                };
            }

            if (preferredDate && !availableAeByFareRoutes[fareRouteCode].selectedDate || orderAeItems.length) {
                availableAeByFareRoutes[fareRouteCode].selectedDate = date;
            }
        });

        vm.availableAeByFareRoutesList = _.keys(availableAeByFareRoutes).map(function (fareRouteCode) {
            return (0, _extends3.default)({}, availableAeByFareRoutes[fareRouteCode], {
                dateVariantsList: _.keys(availableAeByFareRoutes[fareRouteCode].dateVariants)
            });
        });
    }

    function getOrderAeItemsByParams(fare_type, departure_date, departure_code, arrival_code) {
        var result = [];
        if (!vm.orderInfo.editableExtraServicesHeap) {
            return result;
        }
        var orderAeItems = vm.orderInfo.editableExtraServicesHeap.filter(function (item) {
            return item.groupCode === 'aeroexpress';
        });
        if (!orderAeItems.length) {
            return result;
        }
        orderAeItems.forEach(function (item) {

            if (item.fare.fare_type === fare_type && item.departure_date === departure_date && item.departure_code === departure_code && item.arrival_code === arrival_code) {
                result.push(item);
            }
        });
        return result;
    }

    function serviceCountChangeHandler(index, delta) {
        var preventUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var useStream = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var item = vm.availableAeByFareRoutesList[index];
        var params = {
            code: 'aeroexpress',
            departure_code: item.departure_code,
            arrival_code: item.arrival_code,
            date: item.selectedDate,
            fare_type: item.fare,
            count: item.dateVariants[item.selectedDate].alreadySelectedCount + delta
        };
        console.log('params: ', params);
        console.log('useStream: ', useStream);
        console.log('vm.locked: ', vm.locked);
        if ((!vm.locked || useStream) && params.count >= 0 && params.count <= vm.ticketCountLimit) {
            return backend.modifyExtraService(params, preventUpdate);
        }
    }

    function serviceClearHandler(item) {
        var useStream = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var params = {
            code: 'aeroexpress',
            departure_code: item.departure_code,
            arrival_code: item.arrival_code,
            date: item.selectedDate,
            fare_type: item.fare,
            count: 0
        };
        if (!vm.locked || useStream) {
            return backend.modifyExtraService(params, true);
        }
    }

    function closeHandler() {
        vm.onClose();
    }
}

},{"babel-runtime/helpers/extends":3}],116:[function(require,module,exports){
"use strict";

angular.module('app').component('popupAlias', {
    templateUrl: 'modals/popup-alias/popup-alias.html',
    controller: ['$timeout', 'modalTools', PopupAliasController],
    controllerAs: 'vm'
});

function PopupAliasController($timeout, modalTools) {

    var vm = this;
    vm.close = modalTools.closeHandler;

    modalTools.setOpenListener('popup-alias', function (link) {
        $timeout(function () {
            vm.code = link.attr('data-popup-alias');
        });
    });
}

},{}],117:[function(require,module,exports){
"use strict";

angular.module('app').component('popupBaggage', {
    templateUrl: 'modals/popup-baggage/popup-baggage.html',
    controller: ['$scope', '$timeout', 'utils', 'backend', PopupBaggageController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<order',
        imagesPath: '<',
        serviceIconCode: '<',
        card: '<',
        hasNextCard: '<',
        hasPrevCard: '<',
        onSwitchNext: '&',
        onSwitchPrev: '&',
        onClose: '&',
        locked: '<'
    }
});

function PopupBaggageController($scope, $timeout, utils, backend) {

    var vm = this;
    vm.serviceCountChangeHandler = serviceCountChangeHandler;

    vm.$onInit = function () {

        cardDataUpdate();

        var autoSelect = vm.card && vm.card.svcs && vm.card.svcs[0] && vm.card.svcs[0].customProperties && vm.card.svcs[0].customProperties.autoSelect;

        var viewedServicesItems = utils.getViewedServicesItems();
        var hasBeenViewed = utils.hasInList(viewedServicesItems, vm.card.svcs[0].groupCode + '_' + vm.card.svcs[0].rfisc);

        utils.addViewedServiceItem(vm.card.svcs[0].groupCode + '_' + vm.card.svcs[0].rfisc);

        if (hasBeenViewed) {
            return;
        } else if (autoSelect === 'first-pax') {

            var autoSelectItemsParams = [];
            var firstPassengerId = vm.orderInfo.passengers[0].id;

            vm.card.svcs.forEach(function (params) {
                if (!params.alreadySelectedCount && params.passengerId === firstPassengerId) {
                    autoSelectItemsParams.push(params);
                }
            });

            if (autoSelectItemsParams.length) {
                vm.autoSelectFirstPaxLoader = true;
                $timeout(function () {
                    var queue = false;
                    autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params, +1, !isLast);
                        } else {
                            queue = queue.then(function () {
                                return serviceCountChangeHandler(params, +1, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectFirstPaxLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        } else if (autoSelect === 'all-pax') {

            var _autoSelectItemsParams = [];

            vm.card.svcs.forEach(function (params) {
                if (!params.alreadySelectedCount) {
                    _autoSelectItemsParams.push(params);
                }
            });

            if (_autoSelectItemsParams.length) {
                vm.autoSelectAllPaxLoader = true;
                $timeout(function () {
                    var queue = false;
                    _autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === _autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params, +1, !isLast);
                        } else {
                            queue = queue.then(function () {
                                return serviceCountChangeHandler(params, +1, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectAllPaxLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        }
    };

    $scope.$watch('vm.card', cardDataUpdate);

    function cardDataUpdate() {
        vm.svcsByFlightPassenger = utils.groupSvcsByFlightPassenger(vm.card.svcs, vm.orderInfo);
        vm.selectedFlight = vm.selectedFlight || utils.getFirstAvailableSvcsFlight(vm.card.svcs, vm.orderInfo);
    }

    function serviceCountChangeHandler(svc, delta) {
        var preventUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var useStream = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var alreadySelectedCount = svc.alreadySelectedCount || 0;
        if ((!vm.locked || useStream) && (delta < 0 && alreadySelectedCount > 0 || delta > 0 && alreadySelectedCount < svc.limit)) {
            return backend.modifyExtraService({
                code: svc.groupCode,
                passenger_id: svc.passengerId,
                pnr: svc.pnr,
                segment_id: svc.segmentId,
                subgroup: svc.subgroupCode,
                amount: alreadySelectedCount + delta,
                rfisc: svc.rfisc
            }, preventUpdate);
        }
    }
}

},{}],118:[function(require,module,exports){
"use strict";

angular.module('app').component('popupCancelCheckin', {
    templateUrl: 'modals/popup-cancel-checkin/popup-cancel-checkin.html',
    controller: [PopupCancelCheckinController],
    controllerAs: 'vm',
    bindings: {
        pax: '<',
        onConfirm: '&',
        onClose: '&'
    }
});

function PopupCancelCheckinController() {

    var vm = this;

    vm.submitHandler = submitHandler;

    function submitHandler() {
        vm.onConfirm();
        vm.onClose();
    }
}

},{}],119:[function(require,module,exports){
"use strict";

angular.module('app').component('popupChangeSeat', {
    templateUrl: 'modals/popup-change-seat/popup-change-seat.html',
    controller: ['backend', '$timeout', '$q', PopupChangeSeatController],
    controllerAs: 'vm',
    bindings: {
        selectedFlight: '<',
        selectedPassenger: '<',
        orderInfo: '<',
        selectSeat: '<',
        onClose: '&'
    }
});

function PopupChangeSeatController(backend, $timeout, $q) {

    var vm = this;

    vm.seatSelectHandler = seatSelectHandler;
    vm.saveSelectedSeatHandler = saveSelectedSeatHandler;

    vm.$onInit = function () {
        updateViewCraft();
    };

    function updateViewCraft() {

        vm.loading = true;
        vm.viewCraft = false;
        backend.viewCraft(vm.selectedFlight, vm.selectedPassenger).then(function (resp) {
            vm.viewCraft = reformatViewCraft(resp);
            $timeout(highlightSelectedSeats);
        }).finally(function () {
            vm.loading = false;
        });
    }

    function reformatViewCraft(data) {
        if (data.svcs && data.svcs.length) {
            data.cabins.forEach(function (cabin) {
                if (cabin && cabin.tableRows && cabin.tableRows.length) {
                    cabin.tableRows.forEach(function (tableRow) {
                        if (tableRow.length) {
                            tableRow.forEach(function (tableCell) {
                                tableCell.legendIndex = -1;
                                if (tableCell.available && tableCell.rfisc && vm.orderInfo.passengersType === 'CHECKED') {
                                    tableCell.available = false;
                                    tableCell.unavailabilityReason = 'SEAT_WITH_RFISC';
                                }
                            });
                        }
                    });
                }
            });
        }
        return data;
    }

    function highlightSelectedSeats() {
        if (!vm.selectedSeat) {
            vm.selectedSeat = vm.orderInfo.passengers[vm.selectedPassenger].segments[vm.selectedFlight].seat && vm.orderInfo.passengers[vm.selectedPassenger].segments[vm.selectedFlight].seat.number;
        }
        if (vm.viewCraft && vm.viewCraft.cabins && vm.viewCraft.cabins.length) {
            vm.viewCraft.cabins.forEach(function (cabin) {
                if (cabin && cabin.places && cabin.places.length) {
                    cabin.places.forEach(function (place) {
                        if (place && place.seatNumber) {
                            place.selected = place.seatNumber === vm.selectedSeat;
                        }
                    });
                }
            });
        }
    }

    function seatSelectHandler(chair) {
        vm.showPaidSeatsUnavailableMessage = !!chair.rate;
        if (!chair.available || chair.selected || chair.rate) {
            return $q(function (resolve, reject) {
                reject();
            });
        } else {
            vm.selectedSeat = chair.seatNumber;
            highlightSelectedSeats();
            return $q(function (resolve) {
                resolve();
            });
        }
    }

    function saveSelectedSeatHandler() {
        vm.selectSeat({
            segmentIndex: vm.selectedFlight,
            passengerIndex: vm.selectedPassenger,
            seatNumber: vm.selectedSeat
        });
    }
}

},{}],120:[function(require,module,exports){
"use strict";

angular.module('app').component('popupCommonService', {
    templateUrl: 'modals/popup-common-service/popup-common-service.html',
    controller: ['$scope', '$timeout', 'utils', 'backend', PopupCommonServiceController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<order',
        imagesPath: '<',
        serviceIconCode: '<',
        card: '<',
        hasNextCard: '<',
        hasPrevCard: '<',
        onSwitchNext: '&',
        onSwitchPrev: '&',
        onClose: '&',
        locked: '<'
    }
});

function PopupCommonServiceController($scope, $timeout, utils, backend) {

    var vm = this;
    vm.suffixCount = utils.suffixCount;
    vm.serviceCountChangeHandler = serviceCountChangeHandler;
    vm.closeHandler = closeHandler;

    vm.$onInit = function () {

        cardDataUpdate();

        vm.hasAdded = false;
        vm.hasRemoved = false;

        var autoSelect = vm.card && vm.card.svcs && vm.card.svcs[0] && vm.card.svcs[0].customProperties && vm.card.svcs[0].customProperties.autoSelect;

        var viewedServicesItems = utils.getViewedServicesItems();
        var hasBeenViewed = utils.hasInList(viewedServicesItems, vm.card.svcs[0].groupCode + '_' + vm.card.svcs[0].rfisc);

        utils.addViewedServiceItem(vm.card.svcs[0].groupCode + '_' + vm.card.svcs[0].rfisc);

        if (hasBeenViewed) {
            return;
        } else if (autoSelect === 'first-pax') {

            var autoSelectItemsParams = [];
            var firstPassengerId = vm.orderInfo.passengers[0].id;

            vm.card.svcs.forEach(function (params) {
                if (!params.alreadySelectedCount && params.passengerId === firstPassengerId) {
                    autoSelectItemsParams.push(params);
                }
            });

            if (autoSelectItemsParams.length) {
                vm.autoSelectFirstPaxLoader = true;
                $timeout(function () {
                    var queue = false;
                    autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params, +1, !isLast);
                        } else {
                            queue = queue.then(function () {
                                return serviceCountChangeHandler(params, +1, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectFirstPaxLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        } else if (autoSelect === 'all-pax') {

            var _autoSelectItemsParams = [];

            vm.card.svcs.forEach(function (params) {
                if (!params.alreadySelectedCount) {
                    _autoSelectItemsParams.push(params);
                }
            });

            if (_autoSelectItemsParams.length) {
                vm.autoSelectAllPaxLoader = true;
                $timeout(function () {
                    var queue = false;
                    _autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === _autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params, +1, !isLast);
                        } else {
                            queue = queue.then(function () {
                                return serviceCountChangeHandler(params, +1, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectAllPaxLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        }
    };

    $scope.$watch('vm.card', cardDataUpdate);

    function cardDataUpdate() {
        vm.svcsByFlightPassenger = utils.groupSvcsByFlightPassenger(vm.card.svcs, vm.orderInfo);
        vm.selectedFlight = vm.selectedFlight || utils.getFirstAvailableSvcsFlight(vm.card.svcs, vm.orderInfo);
    }

    function serviceCountChangeHandler(svc, delta) {
        var preventUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var useStream = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var alreadySelectedCount = svc.alreadySelectedCount || 0;
        if ((!vm.locked || useStream) && (delta < 0 && alreadySelectedCount > 0 || delta > 0 && alreadySelectedCount < svc.limit)) {
            if (delta > 0) {
                vm.hasAdded = true;
            }
            if (delta < 0) {
                vm.hasRemoved = true;
            }
            return backend.modifyExtraService({
                code: svc.groupCode,
                passenger_id: svc.passengerId,
                pnr: svc.pnr,
                segment_id: svc.segmentId,
                subgroup: svc.subgroupCode,
                amount: alreadySelectedCount + delta,
                rfisc: svc.rfisc
            }, preventUpdate);
        }
    }

    function closeHandler() {

        if (vm.hasAdded) {
            // TODO
        }

        if (vm.hasRemoved) {
            // TODO
        }

        vm.onClose();
    }
}

},{}],121:[function(require,module,exports){
"use strict";

angular.module('app').component('popupConditions', {
    templateUrl: 'modals/popup-conditions/popup-conditions.html',
    controller: [PopupConditionsController],
    controllerAs: 'vm',
    bindings: {
        onAgree: '&'
    }
});

function PopupConditionsController() {

    var vm = this;

    vm.submitHandler = submitHandler;

    function submitHandler() {
        if (vm.searchOrderAgree) {
            vm.onAgree();
        }
    }
}

},{}],122:[function(require,module,exports){
"use strict";

angular.module('app').component('popupConfirmCheckin', {
    templateUrl: 'modals/popup-confirm-checkin/popup-confirm-checkin.html',
    controller: ['backend', PopupConfirmCheckinController],
    controllerAs: 'vm',
    bindings: {
        onSubmit: '&',
        canChoosePassenger: '<',
        phoneRequired: '<',
        emailRequired: '<',
        passengers: '<',
        onClose: '&'
    }
});

function PopupConfirmCheckinController(backend) {

    var vm = this;

    vm.contactsOwnerSelectHandler = contactsOwnerSelectHandler;
    vm.submitHandler = submitHandler;

    vm.$onInit = function () {
        if (vm.canChoosePassenger) {
            vm.contactsOwnerVariants = generateContactsOwnerVariants();
        }
    };

    function contactsOwnerSelectHandler(pax) {
        vm.contactsOwnerSelected = true;
        if (!vm.contacts) {
            vm.contacts = {};
        }
        vm.contacts.phone = pax.phone;
        vm.contacts.email = pax.email;
        vm.contacts.contactsPassengerId = pax.id;
        vm.contacts.contactsPnr = pax.pnr;
    }

    function generateContactsOwnerVariants() {
        var options = [];
        var CONTACTS_OWNER_MIN_AGE = 18;
        vm.passengers.filter(function (pax) {
            var dateOfBirth = moment(pax.dateOfBirth, 'DD.MM.YYYY');
            var todayMoment = moment(o2context.serverDateTime);
            var yearsDiff = todayMoment.diff(dateOfBirth, 'years', false);
            return yearsDiff > CONTACTS_OWNER_MIN_AGE;
        }).forEach(function (pax) {
            options.push({
                id: pax.id,
                pnr: pax.pnr,
                label: pax.lastName + ' ' + pax.firstName,
                phone: pax.phone || '',
                email: pax.email || ''
            });
        });
        if (!options.length) {
            return false;
        }
        options.push({
            id: -1,
            pnr: false,
            label: backend.getAlias('oxygen-check-in.confirmPaidServicesModal.notOrderPax'),
            phone: '',
            email: ''
        });
        return options;
    }

    function submitHandler() {
        if (vm.contactsForm.$valid) {
            if (vm.contacts.contactsPassengerId === -1) {
                delete vm.contacts.contactsPassengerId;
                delete vm.contacts.contactsPnr;
            }
            vm.onSubmit({ $contacts: vm.contacts });
        }
    }
}

},{}],123:[function(require,module,exports){
"use strict";

angular.module('app').component('popupCustomError', {
    templateUrl: 'modals/popup-custom-error/popup-custom-error.html',
    controllerAs: 'vm',
    bindings: {
        errorMessage: '<',
        onClose: '&'
    }
});

},{}],124:[function(require,module,exports){
"use strict";

angular.module('app').component('popupError', {
    templateUrl: 'modals/popup-error/popup-error.html'
});

},{}],125:[function(require,module,exports){
"use strict";

angular.module('app').component('popupFfp', {
    templateUrl: 'modals/popup-ffp/popup-ffp.html',
    controller: [PopupFfpController],
    controllerAs: 'vm',
    bindings: {
        passengers: '<',
        onClose: '&'
    }
});

function PopupFfpController() {

    var vm = this;

    console.log('passengers: ', vm.passengers);
}

},{}],126:[function(require,module,exports){
"use strict";

angular.module('app').component('popupInsurance', {
    templateUrl: 'modals/popup-insurance/popup-insurance.html',
    controller: ['$timeout', '$scope', 'utils', 'backend', PopupInsuranceController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<order',
        imagesPath: '<',
        serviceIconCode: '<',
        onlineMode: '<',
        card: '<',
        hasNextCard: '<',
        hasPrevCard: '<',
        onSwitchNext: '&',
        onSwitchPrev: '&',
        onClose: '&',
        locked: '<'
    }
});

function PopupInsuranceController($timeout, $scope, utils, backend) {

    var vm = this;
    vm.serviceCountChangeHandler = serviceCountChangeHandler;
    vm.switchFlight = switchFlight;

    vm.$onInit = function () {

        cardDataUpdate();

        vm.hasAdded = false;
        vm.hasRemoved = false;

        var autoSelect = vm.card && vm.card.items && vm.card.items[0] && vm.card.items[0].customProperties && vm.card.items[0].customProperties.autoSelect;

        var viewedServicesItems = utils.getViewedServicesItems();
        var hasBeenViewed = utils.hasInList(viewedServicesItems, 'insuranceOnline_' + vm.card.items[0].ins + '-' + vm.card.items[0].tins + '-' + vm.card.items[0].productCode);

        utils.addViewedServiceItem('insuranceOnline_' + vm.card.items[0].ins + '-' + vm.card.items[0].tins + '-' + vm.card.items[0].productCode);

        if (hasBeenViewed) {
            return;
        } else if (autoSelect === 'first-pax') {

            var autoSelectItemsParams = [];
            var firstPassengerId = vm.orderInfo.passengers[0].id;

            vm.card.items.forEach(function (params) {
                if (params.alreadySelectedPrice) {
                    params.alreadySelectedCount = 1;
                }
                if (!params.alreadySelectedCount && params.passengerId === firstPassengerId) {
                    autoSelectItemsParams.push(params);
                }
            });

            if (autoSelectItemsParams.length) {
                vm.autoSelectFirstPaxLoader = true;
                $timeout(function () {
                    var queue = false;
                    autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params, +1, !isLast);
                        } else {
                            queue = queue.then(function () {
                                return serviceCountChangeHandler(params, +1, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectFirstPaxLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        } else if (autoSelect === 'all-pax') {

            var _autoSelectItemsParams = [];

            vm.card.items.forEach(function (params) {
                if (params.alreadySelectedPrice) {
                    params.alreadySelectedCount = 1;
                }
                if (!params.alreadySelectedCount) {
                    _autoSelectItemsParams.push(params);
                }
            });

            if (_autoSelectItemsParams.length) {
                vm.autoSelectAllPaxLoader = true;
                $timeout(function () {
                    var queue = false;
                    _autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === _autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params, +1, !isLast);
                        } else {
                            queue = queue.then(function () {
                                serviceCountChangeHandler(params, +1, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectAllPaxLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        }
    };

    $scope.$watch('vm.card', cardDataUpdate);

    function cardDataUpdate() {
        if (vm.card.items[0].segmentId === null || vm.card.items[0].segmentId === undefined) {
            vm.itemsByPassenger = utils.groupInsuranceItemsPassengers(vm.card.items, vm.orderInfo);
            vm.itemsByFlightPassenger = false;
            vm.selectedFlight = false;
        } else {
            vm.itemsByFlightPassenger = utils.groupInsuranceItemsFlightPassengers(vm.card.items, vm.orderInfo);
            vm.selectedFlight = vm.selectedFlight || utils.getFirstAvailableSvcsFlight(vm.card.items, vm.orderInfo);
            vm.itemsByPassenger = vm.itemsByFlightPassenger[vm.selectedFlight];
        }
    }

    function switchFlight(flightNum) {
        vm.selectedFlight = flightNum;
        vm.itemsByPassenger = vm.itemsByFlightPassenger[flightNum];
    }

    function serviceCountChangeHandler(item, delta) {
        var preventUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var useStream = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var alreadySelectedCount = item.alreadySelectedCount || 0;
        if (!vm.locked || useStream) {
            if (delta > 0) {
                vm.hasAdded = true;
            }
            if (delta < 0) {
                vm.hasRemoved = true;
            }
            if (delta < 0 && alreadySelectedCount > 0) {
                return backend.removeExtraService(getInsuranceSubmitParams(item), preventUpdate);
            }
            if (delta > 0 && (item.limit === undefined || alreadySelectedCount < item.limit)) {
                return backend.modifyExtraService(getInsuranceSubmitParams(item), preventUpdate);
            }
        }
    }

    function getInsuranceSubmitParams(item) {
        var params = {
            code: 'insurance',
            ins: item.ins,
            tins: item.tins
        };
        if (item.passengerId) {
            params.passenger_id = item.passengerId;
        }
        if (item.segmentId) {
            params.segment_id = item.segmentId;
        }
        if (vm.onlineMode) {
            params.code = 'insuranceOnline';
            params.productCode = item.productCode;
        }
        return params;
    }
}

},{}],127:[function(require,module,exports){
"use strict";

angular.module('app').component('popupMeal', {
    templateUrl: 'modals/popup-meal/popup-meal.html',
    controller: ['$scope', '$timeout', 'utils', 'backend', PopupMealController],
    controllerAs: 'vm',
    bindings: {
        orderInfo: '<order',
        imagesPath: '<',
        serviceIconCode: '<',
        card: '<',
        locked: '<',
        hasNextCard: '<',
        hasPrevCard: '<',
        onSwitchNext: '&',
        onSwitchPrev: '&',
        onClose: '&'
    }
});

function PopupMealController($scope, $timeout, utils, backend) {

    var vm = this;
    vm.closeHandler = closeHandler;

    vm.serviceCountChangeHandler = serviceCountChangeHandler;

    vm.$onInit = function () {

        cardDataUpdate();

        vm.hasAdded = false;
        vm.hasRemoved = false;

        var autoSelect = vm.card && vm.card.svcs && vm.card.svcs[0] && vm.card.svcs[0].customProperties && vm.card.svcs[0].customProperties.autoSelect;

        var viewedServicesItems = utils.getViewedServicesItems();
        var hasBeenViewed = utils.hasInList(viewedServicesItems, vm.card.svcs[0].groupCode + '_' + vm.card.svcs[0].rfisc);

        utils.addViewedServiceItem(vm.card.svcs[0].groupCode + '_' + vm.card.svcs[0].rfisc);

        if (hasBeenViewed) {
            return;
        } else if (autoSelect === 'first-pax') {

            var autoSelectItemsParams = [];
            var firstPassengerId = vm.orderInfo.passengers[0].id;

            vm.card.svcs.forEach(function (params) {
                if (!params.alreadySelectedCount && params.passengerId === firstPassengerId) {
                    autoSelectItemsParams.push(params);
                }
            });

            if (autoSelectItemsParams.length) {
                vm.autoSelectFirstPaxLoader = true;
                $timeout(function () {
                    var queue = false;
                    autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params, +1, !isLast);
                        } else {
                            queue = queue.then(function () {
                                return serviceCountChangeHandler(params, +1, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectFirstPaxLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        } else if (autoSelect === 'all-pax') {

            var _autoSelectItemsParams = [];

            vm.card.svcs.forEach(function (params) {
                if (!params.alreadySelectedCount) {
                    _autoSelectItemsParams.push(params);
                }
            });

            if (_autoSelectItemsParams.length) {
                vm.autoSelectAllPaxLoader = true;
                $timeout(function () {
                    var queue = false;
                    _autoSelectItemsParams.forEach(function (params, num) {
                        var isLast = num === _autoSelectItemsParams.length - 1;
                        if (!queue) {
                            queue = serviceCountChangeHandler(params, +1, !isLast);
                        } else {
                            queue = queue.then(function () {
                                return serviceCountChangeHandler(params, +1, !isLast, true);
                            });
                        }
                        if (isLast) {
                            queue.finally(function () {
                                vm.autoSelectAllPaxLoader = false;
                            });
                        }
                    });
                }, 1000);
            }
        }
    };

    $scope.$watch('vm.card', cardDataUpdate);

    function cardDataUpdate() {
        vm.svcsByFlightPassenger = utils.groupSvcsByFlightPassenger(vm.card.svcs, vm.orderInfo);
        vm.selectedFlight = vm.selectedFlight || utils.getFirstAvailableSvcsFlight(vm.card.svcs, vm.orderInfo);
    }

    function serviceCountChangeHandler(svc, delta) {
        var preventUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var useStream = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var alreadySelectedCount = svc.alreadySelectedCount || 0;
        if ((!vm.locked || useStream) && (delta < 0 && alreadySelectedCount > 0 || delta > 0 && alreadySelectedCount < svc.limit)) {
            if (delta > 0) {
                vm.hasAdded = true;
            }
            if (delta < 0) {
                vm.hasRemoved = true;
            }
            return backend.modifyExtraService({
                code: svc.groupCode,
                passenger_id: svc.passengerId,
                pnr: svc.pnr,
                segment_id: svc.segmentId,
                subgroup: svc.subgroupCode,
                amount: alreadySelectedCount + delta,
                rfisc: svc.rfisc
            }, preventUpdate);
        }
    }

    function closeHandler() {

        if (vm.hasAdded) {
            // TODO
        }

        if (vm.hasRemoved) {
            // TODO
        }

        vm.onClose();
    }
}

},{}],128:[function(require,module,exports){
"use strict";

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').component('popupPaxDataEditor', {
    templateUrl: 'modals/popup-pax-data-editor/popup-pax-data-editor.html',
    controller: [PopupPaxDataEditorController],
    controllerAs: 'vm',
    bindings: {
        segNum: '<',
        paxNum: '<',
        orderInfo: '<',
        onSubmit: '&',
        onClose: '&'
    }
});

function PopupPaxDataEditorController() {

    var vm = this;

    vm.$onInit = function () {
        vm.editablePassengerData = (0, _extends3.default)({}, vm.orderInfo.passengers[vm.paxNum].segments[vm.segNum], {
            ffpCard: initFfpCardData(vm.orderInfo.passengers[vm.paxNum].segments[vm.segNum].ffpCardNumber)
        });
        vm.passenger = vm.orderInfo.passengers[vm.paxNum];
        if (vm.orderInfo.passengers[vm.paxNum].child) {
            vm.editablePassengerChildData = (0, _extends3.default)({}, vm.orderInfo.passengers[vm.paxNum].child.segments[vm.segNum], {
                ffpCard: initFfpCardData(vm.orderInfo.passengers[vm.paxNum].child.segments[vm.segNum].ffpCardNumber)
            });
        }
        if (vm.editablePassengerData.document) {
            vm.mode = 'document';
        } else if (vm.editablePassengerData.visa) {
            vm.mode = 'visa';
        }
    };

    function initFfpCardData(defaultValue) {
        return {
            fields: [{
                name: 'ffpCardNumber',
                type: 'text',
                value: defaultValue
            }]
        };
    }
}

},{"babel-runtime/helpers/extends":3}],129:[function(require,module,exports){
"use strict";

angular.module('app').component('popupPaxVisaEditor', {
    templateUrl: 'modals/popup-pax-visa-editor/popup-pax-visa-editor.html',
    controller: ['$scope', 'backend', PopupPaxVisaEditorController],
    controllerAs: 'vm',
    bindings: {
        paxData: '<',
        onSubmit: '&',
        onClose: '&'
    }
});

function PopupPaxVisaEditorController($scope, backend) {

    var vm = this;

    vm.submitHandler = submitHandler;

    vm.aliasCodeByDocumentName = {
        'birthPlace': 'visaBirthPlace',
        'number': 'visaNumber',
        'issueCity': 'visaIssueCity',
        'issueCountry': 'visaIssueCountry',
        'issueDate': 'visaIssueDate',
        'expirationDate': 'visaExpirationDate',
        'hostCountry': 'visaHostCountry'
    };

    $scope.$watch('vm.paxData', function (newPaxData) {
        var visaState = {};
        newPaxData.visa.fields.forEach(function (fileld) {
            if (fileld.name === 'hostCountry' || fileld.name === 'issueCountry') {
                fileld.options = backend.getCountriesList();
                fileld.dictOptions = true;
            }
            visaState[fileld.name] = fileld.value;
        });
        vm.editorState = {
            visa: visaState
        };
    });

    function submitHandler() {
        if (vm.editorForm.$valid) {
            vm.onSubmit({ $data: vm.editorState });
        }
    }
}

},{}],130:[function(require,module,exports){
"use strict";

angular.module('app').component('popupQrAll', {
    templateUrl: 'modals/popup-qr-all/popup-qr-all.html',
    controller: ['backend', PopupQrAllController],
    controllerAs: 'vm',
    bindings: {
        onClose: '&'
    }
});

function PopupQrAllController(backend) {

    var vm = this;

    vm.orderInfo = backend.getOrderInfo();
}

},{}],131:[function(require,module,exports){
"use strict";

angular.module('app').component('popupQr', {
    templateUrl: 'modals/popup-qr/popup-qr.html',
    controller: ['backend', PopupQrController],
    controllerAs: 'vm',
    bindings: {
        passengerNum: '<',
        segmentNum: '<',
        onClose: '&'
    }
});

function PopupQrController(backend) {

    var vm = this;

    vm.orderInfo = backend.getOrderInfo();
}

},{}],132:[function(require,module,exports){
"use strict";

angular.module('app').component('popupRemovedServicesWarning', {
    templateUrl: 'modals/popup-removed-services-warning/popup-removed-services-warning.html',
    controller: ['backend', '$scope', PopupRemovedServicesWarningController],
    controllerAs: 'vm',
    bindings: {
        extraServicesPayment: '<',
        contacts: '<',
        confirm: '<',
        onClose: '&'
    }
});

function PopupRemovedServicesWarningController(backend, $scope) {

    var vm = this;

    vm.submitHandler = submitHandler;

    vm.orderInfo = backend.getOrderInfo();

    $scope.$watch('vm.extraServicesPayment', updateState);

    function updateState() {
        vm.servicesToRemove = vm.extraServicesPayment.servicesToRemove.map(reformatServiceitem);
        vm.servicesToPayFor = vm.extraServicesPayment.servicesToPayFor.map(reformatServiceitem);
    }

    function submitHandler() {
        vm.confirm(vm.contacts);
        vm.onClose();
    }

    function reformatServiceitem(item) {
        if (!item.firstName && !item.lastName && item.passengerId && item.pnr) {
            var pax = _.findWhere(vm.orderInfo.sirenaOrder.passengers, {
                id: item.passengerId,
                pnr: item.pnr
            });
            item.firstName = pax.firstName;
            item.lastName = pax.lastName;
        }
        item.title = generateServiceTitle(item);
        if (!item.totalPrice) {
            if (item.price) {
                item.totalPrice = item.price;
            }
            if (item.fare && item.fare.cost && item.fare.currency) {
                item.totalPrice = item.fare.cost;
                item.currency = item.fare.currency;
            }
        }
        return item;
    }

    function generateServiceTitle(item) {
        switch (item.groupCode) {
            case 'insurance':
                {
                    return backend.getAlias('oxygen-check-in.extraServices.insurance.header');
                }
            case 'aeroexpress':
                {
                    var aeLabel = backend.getAlias('oxygen-check-in.extraServices.aeroexpress.header') + ' / ' + backend.getAlias('oxygen-check-in.extraServices.aeroexpress.label.selectedFare') + ' "' + backend.getAlias('oxygen-check-in.extraServices.aeroexpress.fareName.' + item.fare.fare_type) + '"';
                    if (item.fare.fare_type === 'business') {
                        aeLabel += ', ' + item.departure_date + ' ' + item.departure_time;
                    }
                    return aeLabel;
                }
            default:
                {
                    return item.title;
                }
        }
    }
}

},{}],133:[function(require,module,exports){
"use strict";

angular.module('app').component('popupSelectSegmentsGroup', {
    templateUrl: 'modals/popup-select-segments-group/popup-select-segments-group.html',
    controller: [PopupSelectSegmentsGroupController],
    controllerAs: 'vm',
    bindings: {
        onClose: '&',
        confirm: '<',
        selectCase: '<'
    }
});

function PopupSelectSegmentsGroupController() {

    var vm = this;

    vm.submitHandler = submitHandler;

    vm.selected = 0;

    function submitHandler() {
        vm.confirm(vm.selected);
        vm.onClose();
    }
}

},{}],134:[function(require,module,exports){
"use strict";

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').component('popupSelectSegmentsType', {
    templateUrl: 'modals/popup-select-segments-type/popup-select-segments-type.html',
    controller: ['$scope', PopupSelectSegmentsTypeController],
    controllerAs: 'vm',
    bindings: {
        onClose: '&',
        confirm: '<',
        selectCase: '<'
    }
});

function PopupSelectSegmentsTypeController($scope) {

    var vm = this;

    vm.submitHandler = submitHandler;

    vm.selected = 0;

    $scope.$watch('vm.selectCase', function () {
        vm.selectOptions = generateOptions(vm.selectCase);
    });

    function submitHandler() {
        vm.confirm(vm.selectOptions[vm.selected].value);
        vm.onClose();
    }

    function generateOptions(selectCase) {
        var selectOptions = [];
        var segmentsWherePassengerChecked = selectCase.segmentsWherePassengerChecked,
            segmentsWherePassengerNotChecked = selectCase.segmentsWherePassengerNotChecked;

        if (segmentsWherePassengerChecked && segmentsWherePassengerChecked.length) {
            selectOptions.push({
                data: [].concat((0, _toConsumableArray3.default)(segmentsWherePassengerChecked)),
                value: 'checked'
            });
        }
        if (segmentsWherePassengerNotChecked && segmentsWherePassengerNotChecked.length) {
            selectOptions.push({
                data: [].concat((0, _toConsumableArray3.default)(segmentsWherePassengerNotChecked)),
                value: 'not_checked'
            });
        }

        return selectOptions;
    }
}

},{"babel-runtime/helpers/toConsumableArray":4}],135:[function(require,module,exports){
"use strict";

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('app').component('popupSelectSegments', {
    templateUrl: 'modals/popup-select-segments/popup-select-segments.html',
    controller: ['$scope', PopupSelectSegmentsController],
    controllerAs: 'vm',
    bindings: {
        onClose: '&',
        confirm: '<',
        selectCase: '<'
    }
});

function PopupSelectSegmentsController($scope) {

    var vm = this;

    vm.submitHandler = submitHandler;

    vm.selected = 0;

    $scope.$watch('vm.selectCase', function () {
        vm.selectOptions = generateOptions(vm.selectCase);
    });

    function submitHandler() {
        vm.confirm(JSON.stringify(vm.selectOptions[vm.selected].value));
        vm.onClose();
    }

    function generateOptions(selectCase) {
        var selectOptions = [];
        var openedSegments = selectCase.openedSegments,
            segmentsForThroughCheckIn = selectCase.segmentsForThroughCheckIn;

        if (segmentsForThroughCheckIn && segmentsForThroughCheckIn.length) {
            selectOptions.push({
                data: [].concat((0, _toConsumableArray3.default)(segmentsForThroughCheckIn)),
                value: segmentsForThroughCheckIn.map(function (segment) {
                    return '' + segment.id;
                }),
                through: true
            });
        }
        openedSegments.forEach(function (segment) {
            selectOptions.push({
                data: [segment],
                value: ['' + segment.id]
            });
        });
        return selectOptions;
    }
}

},{"babel-runtime/helpers/toConsumableArray":4}],136:[function(require,module,exports){
"use strict";

angular.module('app').component('popupSendBoardingPass', {
    templateUrl: 'modals/popup-send-boarding-pass/popup-send-boarding-pass.html',
    controller: ['backend', PopupSendBoardingPassController],
    controllerAs: 'vm',
    bindings: {
        passengersCount: '<',
        passengerNum: '<',
        onClose: '&'
    }
});

function PopupSendBoardingPassController(backend) {

    var vm = this;

    vm.deleteMail = deleteMail;
    vm.addMail = addMail;
    vm.submitHandler = submitHandler;

    vm.mailList = [{ email: '' }];

    function deleteMail(num) {
        vm.mailList.splice(num, 1);
    }

    function addMail() {
        vm.mailList.push({ email: '' });
    }

    function generateSelectedPassengers(passengerNum, passengersCount) {
        var passengers = [];
        for (var i = 0; i < passengersCount; i++) {
            if (passengerNum === -1) {
                passengers.push(true);
            } else if (passengerNum === i) {
                passengers.push(true);
            } else {
                passengers.push(false);
            }
        }
        var selectedPassengers = { passengers: passengers };
        return JSON.stringify(selectedPassengers);
    }

    function submitHandler() {
        if (vm.contactsForm.$valid) {

            vm.loading = true;

            backend.boardingPassEmail({
                email: vm.mailList.map(function (item) {
                    return item.email;
                }).join(', '),
                selected: generateSelectedPassengers(vm.passengerNum, vm.passengersCount)
            }).then(function () {
                vm.showSuccessMessage = true;
            }).finally(function () {
                vm.loading = false;
            });
        }
    }
}

},{}],137:[function(require,module,exports){
"use strict";

angular.module('app').controller('BoardingPassScreenController', ['$q', 'utils', 'backend', 'redirect', function ($q, utils, backend, redirect) {

    var vm = this;

    vm.selectSeatHandler = selectSeatHandler;
    vm.cancelCheckinHandler = cancelCheckinHandler;

    vm.loading = true;

    backend.ready.then(function () {
        angular.element('title').text(backend.getAlias('oxygen-check-in.title.boardingPass'));
        updateOrder();
    });

    function updateOrder() {
        vm.loading = true;
        return backend.updateOrderInfo().then(function (orderInfo) {
            if (orderInfo.paymentInProgress && orderInfo.paymentInProgress.redirectTo) {
                // Оставляем экран заблокированным до открытия страницы оплаты
                return;
            }
            if (!orderInfo.passengers || !orderInfo.segments) {
                console.log('Empty order - go to search!');
                redirect.goToSearch();
                return;
            }
            if (!utils.hasSelectedPassengers(orderInfo.passengers)) {
                console.log('Invalid orderInfo - none selected passengers');
                redirect.goToSearch();
                return;
            }
            if (orderInfo.passengersType !== 'CHECKED') {
                console.log('Passengers are not checked');
                redirect.goToSearch();
                return;
            }
            vm.orderInfo = orderInfo;
            vm.loading = false;
        }, function () {
            redirect.goToSearch();
        });
    }

    function selectSeatHandler(params) {
        vm.loading = true;
        return $q(function (resolve, reject) {
            backend.modifyDataSeat(params).then(function () {
                updateOrder().then(resolve, reject);
            }, reject);
        }).finally(function () {
            vm.loading = false;
        });
    }

    function cancelCheckinHandler(passengerNum) {
        vm.loading = true;
        backend.cancelCheckin(passengerNum).then(function (resp) {

            var checkinCancelFor = backend.getAlias('oxygen-check-in.infoMessage.checkinCancelFor');
            var checkinCancelSuccess = backend.getAlias('oxygen-check-in.infoMessage.checkinCancelSuccess');
            var checkinCancelAnd = backend.getAlias('oxygen-check-in.infoMessage.checkinCancelAnd');

            var pax = vm.orderInfo.passengers[passengerNum];
            var paxName = pax.lastName + ' ' + pax.name;
            if (pax.birthDate) {
                paxName += ' (' + pax.birthDate + ')';
            }
            if (pax.child) {
                var childName = pax.child.lastName + ' ' + pax.child.name;
                if (pax.child.birthDate) {
                    childName += ' (' + pax.child.birthDate + ')';
                }
                vm.successCancelMessage = checkinCancelFor + ' ' + paxName + ' ' + checkinCancelAnd + ' ' + childName + ' ' + checkinCancelSuccess;
            } else {
                vm.successCancelMessage = checkinCancelFor + ' ' + paxName + ' ' + checkinCancelSuccess;
            }

            if (resp.needFullOrderUpdate) {
                updateOrder();
            } else {
                vm.orderInfo.passengers.splice(passengerNum, 1);
                vm.loading = false;
            }
        }, function () {
            vm.loading = false;
        });
    }
}]);

},{}],138:[function(require,module,exports){
"use strict";

angular.module('app').controller('CheckInScreenController', ['$q', 'backend', 'utils', 'redirect', function ($q, backend, utils, redirect) {

    var vm = this;

    vm.selectSeatHandler = selectSeatHandler;
    vm.confirmCheckinHandler = confirmCheckinHandler;
    vm.removeSeatHandler = removeSeatHandler;

    vm.loading = true;

    backend.clearUpdateOrderServicesListeners();
    backend.addUpdateOrderServicesListener(function (resps) {
        vm.orderInfo = resps[1];
        vm.es = utils.reformatAvailableExtraServicesByCards(resps[0].extraServiceGroups, vm.orderInfo.sirenaOrder, vm.es);
        vm.esList = utils.getAvailableExtraServicesList(resps[0].extraServiceGroups, vm.es);
        vm.orderServicesLoading = false;
    }, function () {
        redirect.goToSearch();
    });

    backend.addExtraServiceListener(function (state) {
        vm.modifyServicesLoading = !state;
        vm.orderServicesLoading = true;
    });

    backend.addExtraServiceErrorListener(function () {
        vm.modifyServicesLoading = false;
        vm.orderServicesLoading = true;
    });

    backend.ready.then(function () {
        angular.element('title').text(backend.getAlias('oxygen-check-in.title.checkIn'));
        vm.orderServicesLoading = true;
        vm.loading = false;
        backend.updateOrderInfo().then(function (resp) {
            if (resp.sirenaOrder) {
                backend.updateOrderServices().finally(function () {
                    vm.orderServicesLoading = false;
                });
            } else {
                vm.orderInfo = resp;
                vm.orderServicesLoading = false;
            }
        }, function () {
            redirect.goToSearch();
        });
    });

    function selectSeatHandler(params) {
        return $q(function (resolve, reject) {
            backend.selectSeatNumber(params).then(function () {
                backend.updateOrderInfo().then(function (orderInfo) {
                    vm.orderInfo = orderInfo;
                    resolve();
                }, reject);
            }, reject);
        });
    }

    function removeSeatHandler(params) {
        return $q(function (resolve, reject) {
            backend.removeSeatNumber(params).then(function () {
                backend.updateOrderInfo().then(function (orderInfo) {
                    vm.orderInfo = orderInfo;
                    resolve();
                }, reject);
            }, reject);
        });
    }

    function confirmCheckinHandler(contacts) {
        var params = {
            documentsAndFFP: utils.getDocumentsAndFFP(vm.orderInfo.passengers)
        };
        if (contacts) {
            params.email = contacts.email || '';
            params.phone = contacts.phone || '';
            if (contacts.contactsPassengerId && contacts.contactsPnr) {
                params.contactsPassengerId = contacts.contactsPassengerId;
                params.contactsPnr = contacts.contactsPnr;
            }
            vm.contacts = contacts;
        }
        if (vm.extraServicesToRemoveIds) {
            params.extraServicesToRemove = JSON.stringify(vm.extraServicesToRemoveIds);
        }
        vm.confirmLoading = true;
        return $q(function (resolve, reject) {
            backend.confirmCheckin(params).then(function (resp) {
                vm.extraServicesPayment = resp.extraServicesPayment;
                if (resp.extraServicesPayment && resp.extraServicesPayment.servicesToRemove.length) {
                    vm.extraServicesToRemoveIds = resp.extraServicesToRemoveIds;
                    vm.confirmLoading = false;
                    reject(resp);
                } else {
                    redirect.goToBoardingPass();
                    resolve(resp);
                }
            }, function (resp) {
                vm.confirmLoading = false;
                reject(resp);
            });
        });
    }
}]);

},{}],139:[function(require,module,exports){
"use strict";

require('./search/SearchScreenController');
require('./check-in/CheckInScreenController');
require('./boarding-pass/BoardingPassScreenController');
require('./pending-payment-status/PendingPaymentStatusScreenController');

},{"./boarding-pass/BoardingPassScreenController":137,"./check-in/CheckInScreenController":138,"./pending-payment-status/PendingPaymentStatusScreenController":140,"./search/SearchScreenController":141}],140:[function(require,module,exports){
"use strict";

angular.module('app').controller('PendingPaymentStatusScreenController', ['backend', 'redirect', function (backend, redirect) {

    var vm = this;

    vm.clearSessionHandler = clearSessionHandler;

    backend.ready.then(function () {
        vm.pending = true;
        backend.updateOrderInfo().then(function (orderInfo) {
            if (!orderInfo || !orderInfo.paymentInProgress || !orderInfo.paymentInProgress.redirectResultFromIPS) {
                redirect.goToSearch();
            } else {
                backend.waitPayment().then(redirect.goToBoardingPass, function () {
                    vm.pending = false;
                    vm.error = true;
                });
            }
        }, function () {
            vm.pending = false;
            vm.error = true;
        });
    });

    function clearSessionHandler() {
        backend.clearSession().finally(redirect.goToSearch);
    }
}]);

},{}],141:[function(require,module,exports){
"use strict";

angular.module('app').controller('SearchScreenController', ['backend', 'utils', '$q', '$window', '$routeParams', function (backend, utils, $q, $window, $routeParams) {

    var vm = this;

    vm.loading = true;
    vm.orderInfo = false;
    vm.addToOrderHandler = addToOrderHandler;
    vm.clearOrderHandler = clearOrderHandler;
    vm.updateCaptcha = updateCaptcha;

    vm.agreeConditions = agreeConditions;

    backend.clearOrderInfoListeners();

    backend.ready.then(function () {
        vm.showConditions = checkNeedShowConditions();
        angular.element('title').text(backend.getAlias('oxygen-check-in.title.search'));
        if ($window.o2context.debug) {
            var externalSearchParams = [];
            var lastName = utils.getParamFromLocation('lastName');
            var ticketNumber = utils.getParamFromLocation('ticketNumber');
            if (lastName && ticketNumber) {
                externalSearchParams.push({ lastName: lastName, ticketNumber: ticketNumber });
            } else {
                var i = 0;
                lastName = utils.getParamFromLocation('lastName_' + i);
                ticketNumber = utils.getParamFromLocation('ticketNumber_' + i);
                while (lastName && ticketNumber) {
                    externalSearchParams.push({ lastName: lastName, ticketNumber: ticketNumber });
                    i++;
                    lastName = utils.getParamFromLocation('lastName_' + i);
                    ticketNumber = utils.getParamFromLocation('ticketNumber_' + i);
                }
            }
            if (externalSearchParams.length) {
                performAddToOrderChain(externalSearchParams);
            }
        }

        if ($routeParams.ticketNumber && $routeParams.lastName) {
            performAddToOrderChain([{
                ticketNumber: $routeParams.ticketNumber,
                lastName: $routeParams.lastName
            }]);
        }

        backend.updateOrderInfo().then(function (orderInfo) {
            vm.orderInfo = orderInfo;
        }).finally(function () {
            vm.loading = false;
        });
    });

    function updateCaptcha() {
        vm.captcha = new Date().getTime();
    }

    function clearCaptcha() {
        vm.captcha = false;
    }

    function performAddToOrderChain(externalSearchParams) {
        var currentParams = externalSearchParams.pop();
        return $q(function (resolve, reject) {
            addToOrderHandler(currentParams).then(function () {
                if (externalSearchParams.length) {
                    return performAddToOrderChain(externalSearchParams);
                } else {
                    resolve();
                }
            }, reject);
        });
    }

    function addToOrderHandler(searchParams, clearOrder) {
        if (vm.orderInfo && !clearOrder) {
            searchParams.mode = 'add_to_existing_order';
        }
        clearCaptcha();
        return $q(function (resolve, reject) {
            vm.loading = true;
            backend.addToOrder(searchParams).then(function (orderInfo) {
                vm.orderInfo = orderInfo;
                vm.showConditions = checkNeedShowConditions();
                vm.loading = false;
                resolve();
            }, function (resp) {
                if (resp.result === 'SELECT_SEGMENTS_TYPE') {
                    vm.selectSegmentsTypeCase = resp.selectSegmentsTypeCase;
                    console.log('vm.selectSegmentsTypeCase: ', vm.selectSegmentsTypeCase);
                    vm.selectSegmentsTypeCaseConfirm = function (selectedSegmentsType) {
                        searchParams.segmentsType = selectedSegmentsType;
                        return addToOrderHandler(searchParams, clearOrder);
                    };
                } else if (resp.result === 'SELECT_SEGMENTS') {
                    vm.selectSegmentsCase = resp.selectSegmentsCase;
                    console.log('vm.selectSegmentsCase: ', vm.selectSegmentsCase);
                    vm.selectSegmentsCaseConfirm = function (selectedSegments) {
                        console.log('selectedSegments: ', selectedSegments);
                        searchParams.selectedSegments = selectedSegments;
                        return addToOrderHandler(searchParams, clearOrder);
                    };
                } else if (resp.result === 'SELECT_SEGMENTS_GROUP') {
                    vm.selectSegmentsGroupCase = resp.selectSegmentsGroupCase;
                    console.log('vm.selectSegmentsGroupCase: ', vm.selectSegmentsGroupCase);
                    vm.selectSegmentsGroupCaseConfirm = function (segmentsGroupIndex) {
                        console.log('segmentsGroupIndex: ', segmentsGroupIndex);
                        searchParams.segmentsGroupIndex = segmentsGroupIndex;
                        return addToOrderHandler(searchParams, clearOrder);
                    };
                } else if (resp.result === 'CAPTCHA_REQUIRED') {
                    updateCaptcha();
                } else {
                    vm.errorMessage = backend.getAlias(resp.error);
                }
                vm.loading = false;
                reject(resp);
            });
        });
    }

    function clearOrderHandler() {
        vm.orderInfo = false;
    }

    function agreeConditions() {
        vm.showConditions = false;
        if ($window.sessionStorage) {
            $window.sessionStorage.setItem('webskyConditionsAgree', true);
        }
    }

    function checkNeedShowConditions() {
        if (vm.orderInfo) {
            return false;
        }
        if (!backend.getParam('oxygen-check-in.displayConditionsFirst')) {
            return false;
        } else if ($window.sessionStorage) {
            return !$window.sessionStorage.getItem('webskyConditionsAgree');
        } else {
            return true;
        }
    }
}]);

},{}],142:[function(require,module,exports){
"use strict";

angular.module('app').factory('appInit', ['$window', '$rootScope', 'ROUTES', 'backend', function ($window, $rootScope, ROUTES, backend) {
    return function () {

        $rootScope.ROUTES = ROUTES;

        backend.ready.then(function () {
            $rootScope.backendReady = true;
        });

        $rootScope.$on("$routeChangeSuccess", function () {
            $window.scrollTo(0, 0);
        });
    };
}]);

},{}],143:[function(require,module,exports){
"use strict";

require('./appInit');
require('./redirect');
require('./modalTools');

},{"./appInit":142,"./modalTools":144,"./redirect":145}],144:[function(require,module,exports){
"use strict";

angular.module('app').factory('modalTools', ['$timeout', '$window', function ($timeout, $window) {

    var globalListener = void 0;
    var openListeners = {};

    return {
        openHandler: openHandler,
        closeHandler: closeHandler,
        setOpenListener: setOpenListener,
        setGlobalListener: setGlobalListener
    };

    function openHandler(id, link, params) {
        if (globalListener) {
            $window.document.documentElement.addEventListener('keydown', handleEsc);
            globalListener(id);
        }
        $timeout(function () {
            if (openListeners[id]) {
                openListeners[id](link, params);
            }
        });
    }

    function closeHandler() {
        if (globalListener) {
            $window.document.documentElement.removeEventListener('keydown', handleEsc);
            globalListener(false);
        }
    }

    function setOpenListener(id, cb) {
        openListeners[id] = cb;
    }

    function setGlobalListener(cb) {
        globalListener = cb;
    }

    function handleEsc(event) {
        if (event.keyCode === 27) {
            closeHandler();
        }
    }
}]);

},{}],145:[function(require,module,exports){
"use strict";

angular.module('app').factory('redirect', ['$location', 'ROUTES', function ($location, ROUTES) {

    return {
        goToSearch: function goToSearch() {
            $location.path(ROUTES.SEARCH);
        },
        goToCheckIn: function goToCheckIn() {
            $location.path(ROUTES.CHECK_IN);
        },
        goToBoardingPass: function goToBoardingPass() {
            $location.path(ROUTES.BOARDING_PASS);
        }
    };
}]);

},{}]},{},[63]);
